import React from 'react';
import { useEffect as UseEffect, useState as UseState, useRef as UseRef, Fragment } from "react";

import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import DeleteIcon from '@mui/icons-material/Delete';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import LabelIcon from '@mui/icons-material/Label';
import PersonRemoveIcon from '@mui/icons-material/PersonRemove';
import CopyAll from '@mui/icons-material/CopyAll';
import ArrowRight from '@mui/icons-material/ArrowRight';
import Tooltip from '@mui/material/Tooltip';
import CssBaseline from '@mui/material/CssBaseline';
import Grid from '@mui/material/Grid';
import DriveFileMoveIcon from '@mui/icons-material/DriveFileMove';
import { ThemeProvider } from '@mui/material/styles';

import FileComponent from '../../components/File';
import TypographyComponent from '../../components/Typography';
import TextFieldComponent from '../../components/TextField';
import JsonComponent from '../../components/Json';
import NumberComponent from '../../components/Number';
import CurrencyComponent from '../../components/Currency';
import CheckBoxComponent from '../../components/CheckBox';
import SwitchComponent from '../../components/Switch';
import SelectComponent from '../../components/Select';
import DateComponent from '../../components/Date';
import RadioComponent from '../../components/Radio';
import PercentageComponente from '../../components/Percentage';
import dataSource from "../../components/Select/dataSource";

import ordersService from "../../services/orders";
import emailService from "../../services/sendEmail";
import requirementsService from "../../services/requirements";
import questionsService from "../../services/questions";
import constantService from "../../services/constant";
import emailsService from "../../services/emails";
import filesService from "../../services/files";

import initialValues from '../../utils/initialValues';
import whereFunctions from '../../utils/whereFunctions';
import initialGroupSubGroup from '../../utils/initialGroupSubGroup';
import setDefaultValue from '../../utils/setDefaultValue';
import pucValues from '../../utils/puc';
import groupFunctions from '../../utils/groupFunctions';
import globalFunctions from '../../utils/globalFunctions';
import screen from '../../utils/screen';
import constant from '../../utils/constants';

import html2pdf from 'html2pdf.js/dist/html2pdf.min';
import logoTest from '../../img/web_media_banner.png'

const index = () => {
    let user = constant.CLIENT;
    const [constants, setConstants] = UseState([]);
    const [cantidadCondoApod, setCantidadCondoApod] = UseState(1);
    const [instance, setInstance] = UseState([]);
    const [data, setData] = UseState([]);
    const [initialData, setInitialData] = UseState([]);
    const [dataDocumentation, setDataDocumentation] = UseState([]);
    const [emails, setEmails] = UseState([]);
    const [activeStep, setActiveStep] = UseState(0);
    const [skipped, setSkipped] = UseState(new Set());
    const [field, setField] = UseState({});
    const [info, setInfo] = UseState([]);
    const [puc, setPuc] = UseState(null);
    const [order, setOrder] = UseState(null);
    const [uifsro, setUifsro] = UseState(null);
    const [error, setError] = UseState({});
    const [helpText, setHelpText] = UseState({});
    const [loading, setLoading] = UseState(false);
    const [group, setGroup] = UseState([]);
    const [entityDocId, setEntityDocId] = UseState('1');
    const [docIdSave, setDocIdSave] = UseState(1);
    const [accountSeq, setAccountSeq] = UseState(1);
    const [entity, setEntity] = UseState([]);
    const [entityTypeIdOwner, setEntityTypeIdOwmer] = UseState([]);
    const [entityPropIdOwner, setEntityPropIdOwner] = UseState([]);
    const [investorProfile, setInvestorProfile] = UseState([]);
    const [requestCode, setRequestCode] = UseState('');
    const [fieldValidation, setFieldValidation] = UseState(false);
    const [fileURL, setFileURL] = UseState([]);
    const [enableStep, setEnableStep] = UseState(false);
    const [email, setEmail] = UseState('');
    const [cuit, setCuit] = UseState('');
    const boxRef = UseRef(null);

    UseEffect(() => {//CARGA TEST INVERSOR
        questionsService.findAllProfile().then((response) => {
            setInvestorProfile(response.data);
        }).catch((error) => {
            console.log(error);
        });
    }, []);

    UseEffect(() => {

        let instance = constant.CLIENT_REQUIREMENTS;
        setInstance(instance);

        requirementsService.viewRequirementsFindAll(constant.CLIENT, instance).then((response) => {
            let arrayFlag = [];
            for (let r = 0; r < response.data.length; r++) {
                /*if (response.data[r].entityDocId === '1' || response.data[r].entityDocId === '2' || response.data[r].entityDocId === '3' || response.data[r].entityDocId === '4'|| response.data[r].entityDocId === '5' || response.data[r].entityDocId === '9' || response.data[r].entityDocId === '100' || response.data[r].entityDocId === '999') {
                    arrayFlag.push(response.data[r]);
                }*/

                if (response.data[r].onlyAttachment === false) {
                    arrayFlag.push(response.data[r]);
                }
            }

            arrayFlag = orderArray(arrayFlag);
            for (let h = 0; h < arrayFlag.length; h++) {
                for (let t = 0; t < arrayFlag[h].boxes.length; t++) {
                    arrayFlag[h].boxes = orderArray(arrayFlag[h].boxes);
                    for (let y = 0; y < arrayFlag[h].boxes[t].fields.length; y++) {
                        arrayFlag[h].boxes[t].fields = orderArray(arrayFlag[h].boxes[t].fields);
                    }
                }
            }
            setData(arrayFlag);
            setInitialData(arrayFlag);
            setDataDocumentation(response.data);
            setField(initialValues.initialField(arrayFlag));
            setGroup(initialValues.initialArrayGroup(arrayFlag));
            initialGroupSubGroup(arrayFlag, setGroup);

            const fetchData = async (arrayFlag) => {
                setLoading(true);
                let info = await dataSource(arrayFlag, instance, setInfo);
                setDefaultValue(arrayFlag, info, setField);
                setLoading(false);
            };
            fetchData(arrayFlag);
        }).catch((error) => {
            console.log(error);
        });
        constantService.viewConstantsFindAll(constant.CLIENT, instance).then((response) => {
            setConstants(response.data);
        }).catch((error) => {
            console.log(error);
        });
        emailsService.viewEmailsFindAll(constant.CLIENT, instance).then((response) => {
            setEmails(response.data);
        }).catch((error) => {
            console.log(error);
        });


    }, []);

    const handleLoadingChange = (isLoading) => {
        setLoading(isLoading);
    };

    const onValidationField = (error, helpText, idField) => {
        const newErrors = {};
        const newHelpText = {};
        newErrors[idField] = error;
        newHelpText[idField] = helpText;
        setError(newErrors);
        setHelpText(newHelpText);
    }

    const isStepSkipped = (step) => {
        return skipped.has(step);
    };


    const handleNext = (condApod, indexActiveStep) => {
        const newErrors = {};
        const newHelpText = {};
        setLoading(true);

        Object.entries(field).forEach(([id, value]) => {
            data.forEach((itemData) => {
                itemData.boxes.forEach((itemBoxes) => {
                    itemBoxes.fields.forEach((itemFields) => {

                        let idField = `${itemData.entityDocId}_${itemData.id}_${itemFields.id}`;

                        if (!value && itemData.entityDocId === entityDocId && idField === id && itemFields.view === 'edit' && itemFields.mandatory === true) {
                            newErrors[id] = true;
                            newHelpText[id] = 'Campo Obligatorio';
                            setError(newErrors);
                            setHelpText(newHelpText);
                        }
                    })
                })
            })
        });

        let errorFlag = false;
        Object.entries(error).forEach(([id, value]) => {
            if (value) {
                errorFlag = true;
            }
        })

        if (order && !field['1_1_24']) {
            newErrors['1_1_24'] = true;
            newHelpText['1_1_24'] = 'Trámite existente, ingresar Código de Trámite';
            setError(newErrors);
            setHelpText(newHelpText);
        }

        //VALIDACIÓN DE ERRORES
        let comparate = data.length - 3;
        if (Number(entityTypeIdOwner[0].id) === 2) {
            comparate = data.length - 2;
        }

        if (activeStep === Number(comparate) || indexActiveStep) {
            let newArrayErrores = [];
            if (group['999_999_Errores'])
                newArrayErrores.push(group['999_999_Errores'].slice(0, 1)[0])
            let idFieldValidacion;
            data.forEach((itemData) => {
                if (itemData.entityDocId === '999') {
                    itemData.boxes.forEach((itemBoxes) => {
                        itemBoxes.fields.forEach((itemFields) => {
                            if (itemFields.defaultValue === 'validateRequest()') {
                                let idField = `${itemData.entityDocId}_${itemData.id}_${itemFields.id}`;
                                setField(prevState => ({
                                    ...prevState,
                                    [idField]: false
                                }), []);
                                setFieldValidation(false);
                                idFieldValidacion = idField;
                            }
                        })
                    })
                }
            })

            let arrayErrores = [];
            Object.entries(field).forEach(([id, value]) => {
                let indexPage = 0;
                data.forEach((itemData) => {
                    let view = whereFunctions.whereFunctionHeader(itemData, entity);
                    if (view) {
                        let fullName = '';
                        itemData.boxes.forEach((itemBoxes) => {

                            itemBoxes.fields.forEach((itemFields) => {
                                if (itemFields.idFieldTable === 'fullName') {
                                    let idField = `${itemData.entityDocId}_${itemData.id}_${itemFields.id}`;
                                    fullName = field[idField]
                                }
                            })

                            itemBoxes.fields.forEach((itemFields) => {

                                if (itemFields.group !== null) {
                                    itemFields.group.forEach((itemGroup, indexGroup) => {
                                        if (indexGroup === 0) {
                                            let nameGroup = `${itemData.entityDocId}_${itemData.id}_${itemGroup.name}`;
                                            if (itemGroup.name.includes('_')) {
                                                nameGroup = `${itemGroup.name}`;
                                                itemGroup.name = itemGroup.name.split('_')[2];
                                            }
                                            if (group[nameGroup]) {
                                                group[nameGroup].forEach((item1, index) => {
                                                    if (item1.fields !== null) {

                                                        let documento = '';
                                                        item1.fields.forEach((itemFields, indexFields) => {

                                                            let idField = itemFields.id;
                                                            if (itemFields.id)
                                                                if (itemFields.id.split('_').length === 1)
                                                                    idField = `${itemData.entityDocId}_${itemData.id}_${itemFields.id}`;

                                                            if (!value && idField === id && itemFields.view === 'edit' && itemFields.mandatory === true && itemFields.type !== 'Checkbox' && itemFields.type !== 'Switch') {
                                                                let view = true;
                                                                if (itemFields.where !== null && itemFields.where !== undefined) {
                                                                    view = whereFunctions.whereFunction(itemFields, field, itemData);
                                                                }
                                                                if (view === true) {
                                                                    arrayErrores.push({
                                                                        idDocumento: indexPage,
                                                                        documento: `${itemData.name}: ${fullName}`,
                                                                        error: `El campo ${itemFields.name} del grupo es obligatorio`
                                                                    })
                                                                }
                                                            }

                                                            if (itemFields.idFieldTable === 'entityDocId') {
                                                                documento = field[idField];
                                                            }
                                                        })

                                                        if (item1.subGroup !== null && item1.subGroup !== undefined) {
                                                            let fullNameSubgroup = fullName;
                                                            let documentoSubGroup = documento;
                                                            let indexPagSubGroup = indexPage;
                                                            item1.subGroup.forEach((item2, index2) => {
                                                                for (let key in item2) {
                                                                    let nameSubGroup = key;
                                                                    item2[nameSubGroup].forEach((itemSubGroupFields, indexItemSubGroupFields) => {
                                                                        itemSubGroupFields.fields.forEach((itemFields, indexFields) => {

                                                                            let idField = itemFields.id;
                                                                            if (itemFields.id.split('_').length === 1)
                                                                                idField = `${itemData.entityDocId}_${itemData.id}_${itemFields.id}`;

                                                                            if (!value && idField === id && itemFields.view === 'edit' && itemFields.mandatory === true && itemFields.type !== 'Checkbox' && itemFields.type !== 'Switch') {
                                                                                let view = true;
                                                                                if (itemFields.where !== null && itemFields.where !== undefined) {
                                                                                    view = whereFunctions.whereFunction(itemFields, field, itemData);
                                                                                }
                                                                                if (view === true) {
                                                                                    arrayErrores.push({
                                                                                        idDocumento: indexPagSubGroup,
                                                                                        documento: `${itemData.name} ${documentoSubGroup.label}: ${fullNameSubgroup}`,
                                                                                        error: `El campo ${itemFields.name} del subgrupo es obligatorio`
                                                                                    })
                                                                                }
                                                                            }
                                                                        })
                                                                    })
                                                                }
                                                            })
                                                        }

                                                    }
                                                })
                                            }
                                        }
                                    })
                                }
                                else {
                                    let idField = `${itemData.entityDocId}_${itemData.id}_${itemFields.id}`;


                                    if (!value && idField === id && itemFields.view === 'edit' && itemFields.mandatory === true && itemFields.type !== 'Checkbox' && itemFields.type !== 'Switch') {
                                        let view = true;
                                        if (itemFields.where !== null && itemFields.where !== undefined) {
                                            view = whereFunctions.whereFunction(itemFields, field, itemData);
                                        }

                                        if (view === true) {

                                            arrayErrores.push({
                                                idDocumento: indexPage,
                                                documento: `${itemData.name}: ${fullName}`,
                                                error: `El campo ${itemFields.name} es obligatorio`
                                            })
                                        }
                                    }
                                }
                            })
                        })
                        indexPage++;
                    }

                })
            });

            for (let u = 0; u < arrayErrores.length; u++) {

                if (u === 0) {
                    group['999_999_Errores'].forEach((itemGroup) => {
                        if (itemGroup) {
                            itemGroup.idDocumentError = arrayErrores[u].idDocumento;
                            itemGroup.fields.forEach((itemFields, index) => {
                                let idField = itemFields.id;
                                if (itemFields.id.split('_').length === 1)
                                    idField = `999_999_${itemFields.id}`;

                                let value = arrayErrores[u].documento;
                                if (index === 1) {
                                    value = arrayErrores[u].error;
                                }
                                setField(prevState => ({
                                    ...prevState,
                                    [idField]: value
                                }), []);
                            })
                        }
                    })
                } else {
                    addElementGroup('Errores', '999', arrayErrores[u], newArrayErrores, '999');
                }
            }

            if (arrayErrores.length === 0) {
                setField(prevState => ({
                    ...prevState,
                    [idFieldValidacion]: true
                }), []);
                setFieldValidation(true);
            }
            setGroup(prevState => ({
                ...prevState,
                '999_999_Errores': newArrayErrores
            }));
        }


        if (Object.keys(newErrors).length === 0 && errorFlag === false) {

            if (Number(entityDocId) === 1) {
                searchOrder();
            }
            //modifique esto, let entity antes le pasaba el hook entity
            let flag = false;
            for (let r = 0; r < data.length; r++) {
                if (Number(activeStep) === Number(data[r].id)) {
                    if (Number(data[r].entityDocId) !== 1 && Number(data[r].entityDocId) !== 2) {
                        flag = true;
                    }

                }
            }
            let entity = [];
            if (condApod === false) {
                entity = addEntity(data);
                //if (flag)

                addScreen(initialData, entity, flag);
                //modifique esto, let entity antes le pasaba el hook entity
                sendEmailCode();
                saveFiles();
            }


            let newSkipped = skipped;
            if (isStepSkipped(activeStep)) {
                newSkipped = new Set(newSkipped.values());
                newSkipped.delete(activeStep);
            }

            if (indexActiveStep) {
                setActiveStep(indexActiveStep)
            }
            else {
                setActiveStep((prevActiveStep) => prevActiveStep + 1);
            }
            setSkipped(newSkipped);

            //HABILITAR STEPS
            if (activeStep > 5 && (Number(activeStep) + 1) === filteredData.length - 1) {
                setEnableStep(true);
            }

            //Datos Personales
            if ((Number(entityDocId) + 1) === 2) {

                //SETEO MAIL
                if (Number(order) === 0 && Number(entityTypeIdOwner[0].id) === 1) {
                    setField(prevState => ({
                        ...prevState,
                        '2_2_31': field['1_1_15']
                    }), []);
                }

                if (puc !== null && Number(activeStep) === 0) {//**********AGREGUE activeste, SE EJECUTA EN 1 SIEMPRE */
                    data.forEach((itemDoc) => {
                        if (itemDoc.id === '2') {
                            pucValues(puc, null, entityDocId, 0, uifsro, itemDoc, setField, setEntityTypeIdOwmer, setCantidadCondoApod, cantidadCondoApod, info, data, group, addElementGroup, setEntityPropIdOwner);
                        }
                    })
                }

                data.forEach((itemData) => {
                    if (itemData.entityDocId === '2' && itemData.id === '2') {
                        itemData.boxes.forEach((itemBoxs) => {
                            itemBoxs.fields.forEach((itemFields) => {
                                let entityPropId;
                                let accountSeq;
                                let entityTypeId;
                                let idField = `${itemData.entityDocId}_${itemData.id}_${itemFields.id}`
                                switch (itemFields.idFieldTable) {
                                    case 'entityPropId':
                                        entityPropId = idField
                                        break;
                                    case 'accountSeq':
                                        accountSeq = idField
                                        break;
                                    case 'entityTypeId':
                                        entityTypeId = idField
                                        break;
                                    default:
                                        break;
                                }

                                setField(prevState => ({
                                    ...prevState,
                                    [entityPropId]: { id: 1, label: 'Titular' },
                                    [accountSeq]: '01',
                                    [entityTypeId]: entityTypeIdOwner[0],
                                }), []);
                            })
                        })
                    }
                })
            }

            if (condApod === false)
                setEntityDocId(Number(entityDocId) + 1);

            setDocIdSave(Number(activeStep) + 1)

            //3- Registro de FIRMA
            //8- DECLARACION JURADA DE PERSONAS POLITICAMENTE EXPUESTAS
            //11- APODERADOS
            if (Number(entityDocId) < 5) {
                let indexAdd = 0;
                let newArrayFirmantes = [];

                if (group['3_3_Firmantes'])
                    newArrayFirmantes.push(group['3_3_Firmantes'].slice(0, 1)[0])

                let newArrayCargos = [];
                if (group['8_8_Cargo'])
                    newArrayCargos.push(group['8_8_Cargo'].slice(0, 1)[0])

                let newArrayApoderados9 = [];
                if (group['9_9_Cargo'])
                    newArrayApoderados9.push(group['9_9_Cargo'].slice(0, 1)[0])

                let newArrayFirmantesCondiciones = [];
                if (group['10_10_Cargo'])
                    newArrayFirmantesCondiciones.push(group['10_10_Cargo'].slice(0, 1)[0])

                let newArrayApoderados = [];
                if (group['11_11_Cargo'])
                    newArrayApoderados.push(group['11_11_Cargo'].slice(0, 1)[0])

                let newArrayApoderados12 = [];
                if (group['12_12_Cargo'])
                    newArrayApoderados12.push(group['12_12_Cargo'].slice(0, 1)[0])


                for (let r = 0; r < entity.length; r++) {
                    if (entity[r].entityDocId === '2') {
                        let flag = true;
                        for (let b = 0; b < entity[r].boxes.length; b++) {
                            if (flag === true) {
                                let ph = false;
                                for (let a = 0; a < entity[r].boxes[b].fields.length; a++) {
                                    if (entity[r].boxes[b].fields[a].idFieldTable === 'entityTypeId') {
                                        if (entity[r].boxes[b].fields[a].value) {
                                            setEntityTypeIdOwmer([...entityTypeIdOwner, entity[r].boxes[b].fields[a].value]);
                                            if (Number(entity[r].boxes[b].fields[a].value.id) === 1) {
                                                ph = true;
                                            }
                                        }
                                    }
                                }
                                if (ph === true) {
                                    for (let a = 0; a < entity[r].boxes[b].fields.length; a++) {
                                        if (entity[r].boxes[b].fields[a].idFieldTable === 'entityPropId') {
                                            if (entity[r].boxes[b].fields[a].value) {
                                                if (Number(entity[r].boxes[b].fields[a].value.id) === 4) {
                                                    ph = false;
                                                }
                                            }
                                        }
                                    }
                                }

                                if (ph === true) {
                                    flag = false;
                                    indexAdd++;

                                    if (indexAdd > 1) {
                                        data.forEach((itemData) => {
                                            if (Number(itemData.entityDocId) === 3) {
                                                addElementGroup('Firmantes', itemData.id, entity[r], newArrayFirmantes, itemData.entityDocId);
                                            }
                                            if (Number(itemData.entityDocId) === 8) {
                                                addElementGroup('Cargo', itemData.id, entity[r], newArrayCargos, itemData.entityDocId);
                                            }
                                            if (Number(itemData.entityDocId) === 9) {
                                                addElementGroup('Cargo', itemData.id, entity[r], newArrayApoderados9, itemData.entityDocId);
                                            }
                                            if (Number(itemData.entityDocId) === 10) {
                                                addElementGroup('Cargo', itemData.id, entity[r], newArrayFirmantesCondiciones, itemData.entityDocId);
                                            }
                                            if (Number(itemData.entityDocId) === 11) {
                                                addElementGroup('Cargo', itemData.id, entity[r], newArrayApoderados, itemData.entityDocId);
                                            }
                                            if (Number(itemData.entityDocId) === 12) {
                                                addElementGroup('Cargo', itemData.id, entity[r], newArrayApoderados12, itemData.entityDocId);
                                            }
                                        })
                                    } else {

                                        for (let g = 0; g < 6; g++) {
                                            let nameGroup = '3_3_Firmantes';
                                            if (g === 1)
                                                nameGroup = '8_8_Cargo';
                                            if (g === 2)
                                                nameGroup = '9_9_Cargo';
                                            if (g === 3)
                                                nameGroup = '10_10_Cargo';
                                            if (g === 4)
                                                nameGroup = '11_11_Cargo';
                                            if (g === 5)
                                                nameGroup = '12_12_Cargo';

                                            let valueOrderMemoryField = null;
                                            group[nameGroup].forEach((itemGroup) => {
                                                if (itemGroup) {
                                                    itemGroup.fields.forEach((itemFields) => {

                                                        for (let a = 0; a < entity[r].boxes.length; a++) {
                                                            for (let l = 0; l < entity[r].boxes[a].fields.length; l++) {
                                                                if (entity[r].boxes[a].fields[l].idFieldTable === itemFields.idFieldTable) {
                                                                    valueOrderMemoryField = entity[r].boxes[a].fields[l].value
                                                                }
                                                            }
                                                        }
                                                        let idField = itemFields.id;
                                                        if (itemFields.id.split('_').length === 1) {
                                                            idField = `${nameGroup.split('_')[0]}_${nameGroup.split('_')[1]}_${idField}`
                                                        }

                                                        if (idField && valueOrderMemoryField) {

                                                            let idFieldFlag = idField;
                                                            let valueOrderMemoryFieldFlag = valueOrderMemoryField
                                                            setField(prevState => ({
                                                                ...prevState,
                                                                [idFieldFlag]: valueOrderMemoryFieldFlag
                                                            }), []);

                                                        }
                                                    })
                                                }
                                            })
                                        }
                                    }
                                }
                            }
                        }
                    }
                }

                setGroup(prevState => ({
                    ...prevState,
                    '3_3_Firmantes': newArrayFirmantes
                }));

                setGroup(prevState => ({
                    ...prevState,
                    '8_8_Cargo': newArrayCargos
                }));

                setGroup(prevState => ({
                    ...prevState,
                    '9_9_Cargo': newArrayApoderados9
                }));
                setGroup(prevState => ({
                    ...prevState,
                    '10_10_Cargo': newArrayFirmantesCondiciones
                }));
                setGroup(prevState => ({
                    ...prevState,
                    '11_11_Cargo': newArrayApoderados
                }));
                setGroup(prevState => ({
                    ...prevState,
                    '12_12_Cargo': newArrayApoderados12
                }));
                //3- Registro de FIRMA
                //8- DECLARACION JURADA DE PERSONAS POLITICAMENTE EXPUESTAS
                //11- APODERADOS
            }

            //2- Domicilio Real y teléfonos Principales estructura societaria
            setField(prevState => ({
                ...prevState,
                '4_4_65': field['1_1_15']
            }), []);


            if (Number(entityDocId) === 3) {
                let newArrayDomicilio = [];
                if (group['4_4_Domicilio'])
                    newArrayDomicilio.push(group['4_4_Domicilio'].slice(0, 1)[0])

                if (group['2_2_Domicilio']) {
                    let indexFlag = 0;
                    group['2_2_Domicilio'].forEach((itemGroup) => {
                        let isFiscal = false;
                        itemGroup.fields.forEach((itemFields) => {
                            if (itemFields.idFieldTable === 'addressTypeId') {
                                let idField = itemFields.id;
                                if (itemFields.id.split('_').length === 1)
                                    idField = `2_2_${itemFields.id}`;
                                let value = field[idField];
                                if (value) {
                                    if (Number(value.id) === 1) {
                                        isFiscal = true;
                                    }
                                }
                            }
                        })
                        if (isFiscal === true) {
                            if (indexFlag === 0) {
                                itemGroup.fields.forEach((itemFields) => {
                                    if (group['4_4_Domicilio']) {
                                        group['4_4_Domicilio'].forEach((itemGroup1) => {
                                            itemGroup1.fields.forEach((itemFields1) => {
                                                if (itemFields1.idFieldTable === itemFields.idFieldTable) {
                                                    //let idField = itemFields1.id;
                                                    let idField1 = itemFields1.id;
                                                    if (itemFields1.id.split('_').length === 1)
                                                        idField1 = `4_4_${itemFields1.id}`;

                                                    let idField2 = itemFields.id;
                                                    if (itemFields.id.split('_').length === 1)
                                                        idField2 = `2_2_${itemFields.id}`;

                                                    setField(prevState => ({
                                                        ...prevState,
                                                        [idField1]: field[idField2]
                                                    }), []);
                                                }
                                            })
                                        })
                                    }
                                })
                                indexFlag++
                            } else {
                                itemGroup.fields.forEach((itemFields) => {
                                    itemFields.value = field[itemFields.id]
                                })
                                let object = {
                                    boxes: [
                                        {
                                            fields: itemGroup.fields
                                        }
                                    ]
                                }
                                addElementGroup('Domicilio', '4', object, newArrayDomicilio, '4');
                            }
                        }
                    })
                }
                setGroup(prevState => ({
                    ...prevState,
                    '4_4_Domicilio': newArrayDomicilio
                }));

                //TELEFONOS ES
                let newArrayTelefono = [];
                if (group['4_4_Teléfono'])
                    newArrayTelefono.push(group['4_4_Teléfono'].slice(0, 1)[0])

                if (group['2_2_Teléfono']) {
                    let indexFlag = 0;
                    group['2_2_Teléfono'].forEach((itemGroup) => {
                        let isDefault = false;
                        itemGroup.fields.forEach((itemFields) => {
                            if (itemFields.idFieldTable === 'isDefault') {
                                let idField = itemFields.id;
                                if (itemFields.id.split('_').length === 1)
                                    idField = `2_2_${itemFields.id}`;
                                isDefault = field[idField];
                            }
                        })

                        if (isDefault === true) {
                            if (indexFlag === 0) {
                                itemGroup.fields.forEach((itemFields) => {
                                    if (group['4_4_Teléfono']) {
                                        group['4_4_Teléfono'].forEach((itemGroup1) => {
                                            itemGroup1.fields.forEach((itemFields1) => {
                                                if (itemFields1.idFieldTable === itemFields.idFieldTable) {
                                                    //let idField = itemFields1.id;
                                                    let idField1 = itemFields1.id;
                                                    if (itemFields1.id.split('_').length === 1)
                                                        idField1 = `4_4_${itemFields1.id}`;

                                                    let idField2 = itemFields.id;
                                                    if (itemFields.id.split('_').length === 1)
                                                        idField2 = `2_2_${itemFields.id}`;

                                                    setField(prevState => ({
                                                        ...prevState,
                                                        [idField1]: field[idField2]
                                                    }), []);

                                                }
                                            })
                                        })
                                    }
                                })
                                indexFlag++
                            } else {
                                itemGroup.fields.forEach((itemFields) => {
                                    itemFields.value = field[itemFields.id]
                                })
                                let object = {
                                    boxes: [
                                        {
                                            fields: itemGroup.fields
                                        }
                                    ]
                                }
                                addElementGroup('Teléfono', '4', object, newArrayTelefono, '4');
                            }
                        }
                    })
                }
                setGroup(prevState => ({
                    ...prevState,
                    '4_4_Teléfono': newArrayTelefono
                }));
            }

            if (Number(entityDocId) === 5) {
                //BENEFICIARIOS FINALES DECLARACION FISCAL
                let newArrayBeneficiariosFinales = [];

                if (group['9_9_Beneficiarios Finales'])
                    newArrayBeneficiariosFinales.push(group['9_9_Beneficiarios Finales'].slice(0, 1)[0])
                newArrayBeneficiariosFinales[0].subGroup[0].subGroup_9_9_Domicilios_BF = [newArrayBeneficiariosFinales[0].subGroup[0].subGroup_9_9_Domicilios_BF[0]]

                group['4_4_Beneficiarios Finales'].forEach((itemGroup, index) => {
                    if (index === 0) {
                        itemGroup.fields.forEach((itemFields) => {
                            if (group['9_9_Beneficiarios Finales']) {
                                group['9_9_Beneficiarios Finales'].forEach((itemGroup1) => {
                                    itemGroup1.fields.forEach((itemFields1) => {
                                        if (itemFields1.idFieldTable === itemFields.idFieldTable) {
                                            let idField1 = itemFields1.id;
                                            if (itemFields1.id.split('_').length === 1)
                                                idField1 = `9_9_${itemFields1.id}`;

                                            let idField2 = itemFields.id;
                                            if (itemFields.id.split('_').length === 1)
                                                idField2 = `4_4_${itemFields.id}`;
                                            setField(prevState => ({
                                                ...prevState,
                                                [idField1]: field[idField2]
                                            }), []);
                                        }
                                    })
                                })
                            }
                        })

                        if (itemGroup.subGroup !== null) {
                            itemGroup.subGroup.forEach((itemSubGroup1) => {
                                itemSubGroup1['subGroup_4_4_Domicilios_BF'].forEach((itemSubGroup_4_4_Domicilios_BF, indexSubGroup_4_4_Domicilios_BF) => {
                                    if (indexSubGroup_4_4_Domicilios_BF === 0) {
                                        itemSubGroup_4_4_Domicilios_BF.fields.forEach((fields1) => {

                                            if (group['9_9_Beneficiarios Finales']) {
                                                group['9_9_Beneficiarios Finales'].forEach((itemSubGroup2) => {
                                                    itemSubGroup2.subGroup.forEach((itemGroup1) => {
                                                        itemGroup1['subGroup_9_9_Domicilios_BF'].forEach((itemGroup1) => {
                                                            itemGroup1.fields.forEach(fields2 => {

                                                                if (fields1.idFieldTable === fields2.idFieldTable) {
                                                                    let idField1 = fields2.id;
                                                                    if (fields2.id.split('_').length === 1)
                                                                        idField1 = `9_9_${fields2.id}`;

                                                                    let idField2 = fields1.id;
                                                                    if (fields1.id.split('_').length === 1)
                                                                        idField2 = `4_4_${fields1.id}`;
                                                                    setField(prevState => ({
                                                                        ...prevState,
                                                                        [idField1]: field[idField2]
                                                                    }), []);
                                                                }

                                                            })
                                                        })
                                                    })

                                                })
                                            }
                                        })
                                    } else {
                                        itemSubGroup_4_4_Domicilios_BF.fields.forEach((itemFieldsSubGroup) => {
                                            itemFieldsSubGroup.value = field[itemFieldsSubGroup.id]
                                        })

                                        let object = {
                                            fields: itemSubGroup_4_4_Domicilios_BF.fields
                                        }
                                        addElementSubGroup('Beneficiarios Finales', '9', 'subGroup_9_9_Domicilios_BF', index, indexSubGroup_4_4_Domicilios_BF, object, newArrayBeneficiariosFinales, null);
                                    }
                                })
                            })
                        }
                    }
                    else {

                        itemGroup.fields.forEach((itemFields) => {
                            itemFields.value = field[itemFields.id]
                        })

                        let object = {
                            boxes: [
                                {
                                    fields: itemGroup.fields
                                }
                            ]
                        }
                        addElementGroup('Beneficiarios Finales', '9', object, newArrayBeneficiariosFinales, '9');

                        //FIELDS DEL SUBGRUPO                
                        itemGroup.subGroup.forEach((itemSubGroup) => {
                            itemSubGroup.subGroup_4_4_Domicilios_BF.forEach((item, indexSubGroup) => {

                                if (indexSubGroup === 0) {
                                    item.fields.forEach((itemFieldsSubGroup) => {

                                        newArrayBeneficiariosFinales.forEach((itemGroup1, indexGroup1) => {

                                            if (indexGroup1 === index) {
                                                itemGroup1.subGroup.forEach((itemSubGroup1) => {
                                                    itemSubGroup1.subGroup_9_9_Domicilios_BF.forEach((item1) => {
                                                        item1.fields.forEach((itemFieldsSubGroup1) => {

                                                            if (itemFieldsSubGroup1.idFieldTable === itemFieldsSubGroup.idFieldTable) {
                                                                let idField1 = itemFieldsSubGroup1.id;
                                                                if (itemFieldsSubGroup1.id.split('_').length === 1)
                                                                    idField1 = `9_9_${itemFieldsSubGroup1.id}`;

                                                                let idField2 = itemFieldsSubGroup.id;
                                                                if (itemFieldsSubGroup.id.split('_').length === 1)
                                                                    idField2 = `4_4_${itemFieldsSubGroup.id}`;

                                                                if (field[idField2])
                                                                    setField(prevState => ({
                                                                        ...prevState,
                                                                        [idField1]: field[idField2]
                                                                    }), []);
                                                            }
                                                        })
                                                    })
                                                })

                                            }
                                        })

                                    })
                                } else {

                                    item.fields.forEach((itemFieldsSubGroup) => {
                                        itemFieldsSubGroup.value = field[itemFieldsSubGroup.id]
                                    })

                                    let object = {
                                        fields: item.fields
                                    }
                                    addElementSubGroup('Beneficiarios Finales', '9', 'subGroup_9_9_Domicilios_BF', index, indexSubGroup, object, newArrayBeneficiariosFinales, null);
                                }
                            })
                        })

                    }
                })
                setGroup(prevState => ({
                    ...prevState,
                    '9_9_Beneficiarios Finales': newArrayBeneficiariosFinales
                }));
            }
            //9-Beneficiarios FINALES

            //DOMICILIO FISCAL
            if (Number(entityDocId) === 3 && Number(entityTypeIdOwner[0].id) === 2) {
                let newArrayDomicilioFiscal = [];
                if (group['9_9_Fiscal'])
                    newArrayDomicilioFiscal.push(group['9_9_Fiscal'].slice(0, 1)[0])

                if (group['2_2_Fiscal']) {
                    let indexFlag = 0;
                    group['2_2_Fiscal'].forEach((itemGroup) => {

                        if (indexFlag === 0) {
                            itemGroup.fields.forEach((itemFields) => {
                                if (group['9_9_Fiscal']) {
                                    group['9_9_Fiscal'].forEach((itemGroup1) => {
                                        itemGroup1.fields.forEach((itemFields1) => {
                                            if (itemFields1.idFieldTable === itemFields.idFieldTable) {
                                                //let idField = itemFields1.id;
                                                let idField1 = itemFields1.id;
                                                if (itemFields1.id.split('_').length === 1)
                                                    idField1 = `9_9_${itemFields1.id}`;

                                                let idField2 = itemFields.id;
                                                if (itemFields.id.split('_').length === 1)
                                                    idField2 = `2_2_${itemFields.id}`;


                                                setField(prevState => ({
                                                    ...prevState,
                                                    [idField1]: field[idField2]
                                                }), []);
                                            }
                                        })
                                    })
                                }
                            })
                            indexFlag++
                        } else {
                            itemGroup.fields.forEach((itemFields) => {
                                itemFields.value = field[itemFields.id]
                            })
                            let object = {
                                boxes: [
                                    {
                                        fields: itemGroup.fields
                                    }
                                ]
                            }
                            addElementGroup('Fiscal', '9', object, newArrayDomicilioFiscal, '9');
                        }

                    })
                }
                setGroup(prevState => ({
                    ...prevState,
                    '9_9_Fiscal': newArrayDomicilioFiscal
                }));
            }

            setLoading(false)
            if (boxRef.current) {
                boxRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }

        }
    };

    const generateIdOrder = () => {
        const letras = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
        const numeros = '0123456789';
        const nuevoValor = [];

        for (let i = 0; i < 3; i++) {
            nuevoValor.push(letras[Math.floor(Math.random() * letras.length)]);
        }

        for (let i = 0; i < 3; i++) {
            nuevoValor.push(numeros[Math.floor(Math.random() * numeros.length)]);
        }

        return nuevoValor.join('');
    };

    const saveFiles = () => {

        let arrayFiles = [];
        data.forEach((itemData) => {
            itemData.boxes.forEach((itemBoxs) => {
                itemBoxs.fields.forEach((itemField) => {
                    if (itemField.group !== null) {
                        itemField.group.forEach((itemGroup, indexGroup) => {
                            if (indexGroup === 0) {
                                let nameGroup = `${itemData.entityDocId}_${itemData.id}_${itemGroup.name}`;
                                if (itemGroup.name.includes('_')) {
                                    nameGroup = `${itemGroup.name}`;
                                    itemGroup.name = itemGroup.name.split('_')[2];
                                }

                                //if (group[nameGroup] && nameGroup.includes('Adjuntos')) {
                                if (group[nameGroup] && nameGroup.includes('Req')) {
                                    group[nameGroup].forEach((item1, index) => {
                                        if (item1.subGroup !== null && item1.subGroup !== undefined) {
                                            item1.subGroup.forEach((item2, index2) => {
                                                for (let key in item2) {
                                                    let nameSubGroup = key;
                                                    item2[nameSubGroup].forEach((itemSubGroupFields, indexItemSubGroupFields) => {
                                                        itemSubGroupFields.fields.forEach((itemFields, indexFields) => {
                                                            if (itemFields.type === 'File') {
                                                                let idField = itemFields.id;
                                                                if (field[idField]) {
                                                                    arrayFiles.push(field[idField])
                                                                }
                                                            }
                                                        })
                                                    })
                                                }
                                            })
                                        }
                                    })
                                }
                            }
                        })
                    }
                })
            })
        })

        if (arrayFiles.length > 0) {
            const formData = new FormData();

            for (let r = 0; r < arrayFiles.length; r++) {
                formData.append('attachments', arrayFiles[r]);
            }

            formData.append('bucket', `wb-${constant.CLIENT}`);
            formData.append('folder', `${instance}/orders/${requestCode}`);

            filesService.saveFiles(formData).then((response) => {

            }).catch((error) => {
                console.log(error);
            });
        }
    }

    const sendEmailCode = () => {

        let existeEntity;
        for (let h = 0; h < entity.length; h++) {
            for (let t = 0; t < entity[h].boxes.length; t++) {
                for (let y = 0; y < entity[h].boxes[t].fields.length; y++) {
                    if (entity[h].boxes[t].fields[y].idFieldTable === 'argTin') {
                        existeEntity = entity[h].boxes[t].fields[y].value;
                    }
                }
            }
        }

        if (!requestCode && existeEntity !== undefined) {
            ordersService.findAllId(user, instance).then((response) => {
                let arrayOrders = response.data;
                let requestCode = generateIdOrder();
                while (arrayOrders.includes(requestCode)) {
                    requestCode = generateIdOrder();
                }
                /*let mail = {
                    recipient: field['1_1_15'],
                    msgBody: `El ID de su órden generada es: \n\nID Órden: ${requestCode}\n\nSaludos \n\nWinvest APP`,
                    subject: 'Órden generada Winvest APP'
                }*/
                let mail = {
                    recipient: field['1_1_15'],
                    msgBody: null,
                    subject: null
                }
                const variables = { requestCode };

                for (let k = 0; k < emails.length; k++) {
                    for (let d = 0; d < emails[k].type.length; d++) {
                        if (emails[k].id === 'requirement') {
                            if (emails[k].type[d].name === 'newOrder') {
                                let msgBody = emails[k].type[d].msgBody;
                                msgBody = msgBody.replace(/\$_(\w+)/g, (match, p1) => variables[p1] || match);
                                msgBody = msgBody.replace(/\\n/g, '\n');
                                mail.msgBody = msgBody;

                                let subject = emails[k].type[d].subject;
                                subject = subject.replace(/\$_(\w+)/g, (match, p1) => variables[p1] || match);
                                subject = subject.replace(/\\n/g, '\n');
                                mail.subject = subject;
                            }
                        }
                    }
                }

                let entityDocId = [1, 2]
                saveOrder(requestCode, entityDocId);
                for (let h = 0; h < data.length; h++) {
                    for (let t = 0; t < data[h].boxes.length; t++) {
                        for (let y = 0; y < data[h].boxes[t].fields.length; y++) {
                            if (data[h].boxes[t].fields[y].defaultValue === 'requestCode()') {

                                let idField = data[h].boxes[t].fields[y].id;
                                if (data[h].boxes[t].fields[y].id.split('_').length === 1)
                                    idField = `${data[h].entityDocId}_${data[h].id}_${data[h].boxes[t].fields[y].id}`;
                                setField(prevState => ({
                                    ...prevState,
                                    [idField]: requestCode
                                }), []);
                            }
                        }
                    }
                }
                setRequestCode(requestCode)
                emailService.sendEmail(mail).then((response) => {
                }).catch((error) => {
                    console.log(error);
                });
            }).catch((error) => {
                console.log(error);
            });
        } else {
            //actualiza

            if (requestCode && existeEntity !== undefined) {
                let docId = [1, 2];
                for (let i = 3; i <= docIdSave; i++) {
                    docId.push(i);
                }
                saveOrder(requestCode, docId);
            }
        }
    }

    const addEntity = (data) => {
        for (let h = 0; h < data.length; h++) {
            for (let t = 0; t < data[h].boxes.length; t++) {
                for (let key in field) {

                    for (let t = 0; t < data[h].boxes.length; t++) {
                        for (let y = 0; y < data[h].boxes[t].fields.length; y++) {

                            let idField = `${data[h].entityDocId}_${data[h].id}_${data[h].boxes[t].fields[y].id}`
                            if (idField === key) {
                                data[h].boxes[t].fields[y].value = field[key];
                            }
                        }
                    }
                }
            }
        }

        let arrayData = [];
        let ultimoId;
        data.forEach((itemData) => {
            if (Number(itemData.entityDocId) === 2) {
                itemData.idEntity = itemData.id;
                arrayData.push(itemData);
                ultimoId = Number(itemData.id);
            }
        })

        if (group['5_5_Autorizados']) {
            group['5_5_Autorizados'].forEach((item) => {
                let existe = false;

                item.fields.forEach((itemFields) => {

                    let idField = itemFields.id;
                    if (itemFields.id.split('_').length === 1)
                        idField = `5_5_${itemFields.id}`
                    if (itemFields.idFieldTable === 'argTin' || itemFields.idFieldTable === 'tin') {
                        let cuit = field[idField];
                        if (cuit)
                            existe = true;
                    }
                    itemFields.value = field[idField];
                })
                if (existe === true) {
                    ultimoId++;
                    arrayData.push({
                        idEntity: ultimoId,
                        entityDocId: '5',
                        boxes: [item]
                    });
                }

            })
        }
        setEntity(arrayData);
        return arrayData;
    }

    const saveOrder = (idOrder, arrayDocId, status) => {

        let arrayFlag = JSON.parse(JSON.stringify(data));
        //let indexFlag = 1;
        for (let h = 0; h < arrayFlag.length; h++) {
            for (let f = 0; f < arrayDocId.length; f++) {
                if (Number(arrayDocId[f]) === Number(arrayFlag[h].entityDocId)) {

                    ///arrayFlag[h].id = indexFlag;
                    //indexFlag++;
                    for (let key in field) {

                        for (let t = 0; t < arrayFlag[h].boxes.length; t++) {
                            for (let y = 0; y < arrayFlag[h].boxes[t].fields.length; y++) {

                                let idField = arrayFlag[h].boxes[t].fields[y].id;
                                if (idField) {
                                    if (arrayFlag[h].boxes[t].fields[y].id.split('_').length === 1)
                                        idField = `${arrayFlag[h].entityDocId}_${arrayFlag[h].id}_${arrayFlag[h].boxes[t].fields[y].id}`

                                    if (idField === key) {

                                        if (typeof field[key] === 'object' && field[key] !== null) {
                                            if (field[key].id)
                                                arrayFlag[h].boxes[t].fields[y].value = field[key].id;
                                            else {
                                                arrayFlag[h].boxes[t].fields[y].value = JSON.stringify(field[key]).toString();
                                            }
                                        } else {

                                            arrayFlag[h].boxes[t].fields[y].value = field[key];
                                        }
                                    }
                                    if (arrayFlag[h].boxes[t].fields[y].idFieldTable === 'requestId')
                                        arrayFlag[h].boxes[t].fields[y].value = idOrder;
                                    if (arrayFlag[h].boxes[t].fields[y].idFieldTable === 'status' && status)
                                        arrayFlag[h].boxes[t].fields[y].value = status;

                                    if (arrayFlag[h].boxes[t].fields[y].defaultValue === 'entityIx()')
                                        arrayFlag[h].boxes[t].fields[y].value = arrayFlag[h].entityIx;
                                }
                            }
                        }
                    }
                }
            }
        }

        let arrayData = [];

        arrayFlag.forEach((itemData) => {
            arrayDocId.forEach((itemDocId) => {
                if (Number(itemData.entityDocId) === Number(itemDocId)) {
                    itemData.boxes.forEach((itemBoxes) => {
                        let arrayFieldsFlag = [];
                        itemBoxes.fields.forEach((itemFields) => {
                            if (itemFields.group === null) {
                                arrayFieldsFlag.push(itemFields);
                            } else {

                                itemFields.group.forEach((itemGroup, indexGroup) => {

                                    if (indexGroup === 0) {
                                        let subGroup = null;
                                        let originalNameSubGroup = ''
                                        itemGroup.fields.forEach((itemFieldGroup, m) => {
                                            if (itemFieldGroup.subGroup !== null) {
                                                itemFieldGroup.subGroup.forEach((itemFieldSubGroup) => {
                                                    originalNameSubGroup = itemFieldSubGroup.name;
                                                    if (itemFieldSubGroup.name.includes('subGroup_'))
                                                        subGroup = itemFieldSubGroup.name;
                                                    else
                                                        subGroup = `subGroup_${itemData.entityDocId}_${itemData.id}_${itemFieldSubGroup.name}`;
                                                })
                                            }
                                        })
                                        let originalNaneGroup = itemGroup.name;
                                        let nameGroup = `${itemData.entityDocId}_${itemData.id}_${itemGroup.name}`;
                                        if (Number(itemData.entityDocId) === 2 || Number(itemData.entityDocId) === 9 || Number(itemData.entityDocId) === 100)
                                            nameGroup = `${itemData.entityDocId}_${itemData.id}_${itemGroup.name}`;
                                        let arrayGroup = [];

                                        if (group[nameGroup]) {
                                            group[nameGroup].forEach((itemGroup) => {
                                                let objectGroup = {};
                                                //objectGroup.name = nameGroup;
                                                objectGroup.name = originalNaneGroup;
                                                objectGroup.id = itemData.id;
                                                let arrayFieldsGroupFlag = [];

                                                itemGroup.fields.forEach((itemGroupFields) => {

                                                    let idField = itemGroupFields.id;
                                                    if (itemGroupFields.id)
                                                        if (itemGroupFields.id.split('_').length === 1)
                                                            idField = `${itemData.entityDocId}_${itemData.id}_${itemGroupFields.id}`

                                                    if (typeof field[idField] === 'object' && field[idField] !== null) {
                                                        itemGroupFields.value = field[idField].id;
                                                    } else {
                                                        itemGroupFields.value = field[idField];
                                                    }
                                                    arrayFieldsGroupFlag.push(itemGroupFields);
                                                })
                                                //SUBGROUP

                                                if (itemGroup.subGroup !== null && subGroup !== null) {

                                                    let arraySubGroupFlag = [];
                                                    itemGroup.subGroup.forEach((itemSubGroupFields) => {


                                                        if (itemSubGroupFields[subGroup]) {


                                                            itemSubGroupFields[subGroup].forEach((fieldsSubgroup) => {
                                                                let objectSubGroup = {};
                                                                let arrayFieldsSubGroupFlag = [];
                                                                //objectSubGroup.name = fieldsSubgroup.name;
                                                                objectSubGroup.name = originalNameSubGroup;
                                                                objectSubGroup.id = fieldsSubgroup.id;

                                                                fieldsSubgroup.fields.forEach((itemSubGroupFields) => {
                                                                    let idField = itemSubGroupFields.id;
                                                                    if (itemSubGroupFields.id.split('_').length === 1)
                                                                        idField = `${itemData.entityDocId}_${itemData.id}_${itemSubGroupFields.id}`
                                                                    if (typeof field[idField] === 'object' && field[idField] !== null) {
                                                                        itemSubGroupFields.value = field[idField].id;
                                                                    } else {
                                                                        itemSubGroupFields.value = field[idField];
                                                                    }
                                                                    arrayFieldsSubGroupFlag.push(itemSubGroupFields);
                                                                })

                                                                if (arrayFieldsSubGroupFlag.length > 0) {
                                                                    objectSubGroup.fields = arrayFieldsSubGroupFlag;
                                                                    arraySubGroupFlag.push(objectSubGroup);

                                                                }
                                                            })
                                                        }
                                                    })
                                                    arrayFieldsGroupFlag.push({
                                                        "subGroup": arraySubGroupFlag
                                                    });
                                                }
                                                //SUBGROUP
                                                objectGroup.fields = arrayFieldsGroupFlag;

                                                arrayGroup.push(objectGroup);
                                            })
                                        }
                                        let objectoGrupoAgregar = {};
                                        objectoGrupoAgregar.order = itemFields.order;

                                        objectoGrupoAgregar.group = arrayGroup;
                                        arrayFieldsFlag.push(objectoGrupoAgregar);
                                    }
                                })
                            }
                        })
                        itemBoxes.fields = arrayFieldsFlag;
                    })
                    arrayData.push(itemData);
                }
            })
        })

        let request = {};
        request.context = 'onBoarding';
        request.argTin = field['1_1_16'];
        request.order = arrayData;
        ordersService.save(user, instance, idOrder, request).then(() => {
        }).catch((error) => {
            console.log(error);
        });
    }


    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
        setEntityDocId(Number(entityDocId) - 1);
        if (boxRef.current) {
            boxRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    };

    const redirect = (index) => {

        if (index !== undefined && index !== null) {
            let indexRedirect = Number(index);

            setActiveStep(indexRedirect);
            if (boxRef.current) {
                boxRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        }
    };

    const redirectError = (index) => {


        if (index !== undefined && index !== null && enableStep === true && Number(index) > 1) {
            //setActiveStep(indexRedirect);
            /*if (boxRef.current) {
                boxRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }*/
            handleNext(false, index);
        }
    };

    const orderArray = array => {
        let temporal = 0;
        for (let i = 0; i < array.length; i++) {
            for (let j = 1; j < (array.length - i); j++) {
                if (array[j - 1].order > array[j].order) {
                    temporal = array[j - 1];
                    array[j - 1] = array[j];
                    array[j] = temporal;
                }
            }
        }
        return array;
    }

    const handleFieldChange = (e, newValue, id, idFieldTable, itemDoc, nameGroup, indexGroup, nameSubGroup, indexSubGroup) => {

        let changeValue;
        if (e !== null) {
            changeValue = e.target.value;
            if (e.target.type === 'checkbox') {
                changeValue = e.target.checked
            }

            if (e.target.type === 'file') {
                changeValue = e.target.files[0]
                if (changeValue) {
                    const file = URL.createObjectURL(changeValue);
                    //setFileURL(fileURL);
                    let newElement = {
                        file,
                        nameSubGroup,
                        indexSubGroup
                    }

                    setFileURL([...fileURL, newElement]);
                }
            }
        }
        if (newValue) {
            changeValue = newValue;
        }
        if (changeValue !== undefined) {
            if (idFieldTable === 'legalName' || idFieldTable === 'firstName' || idFieldTable === 'lastName' || idFieldTable === 'fullName')
                changeValue = changeValue.toString().toUpperCase();

            if (idFieldTable === 'email' && Number(itemDoc.entityDocId) === 1)
                setEmail(changeValue)

            if ((idFieldTable === 'tin' || idFieldTable === 'pin') && Number(itemDoc.entityDocId) === 1)
                setCuit(changeValue)

            setField(prevState => ({
                ...prevState,
                [id]: changeValue,
            }), []);

            if (idFieldTable === 'entityTypeId' && itemDoc.entityDocId === '1') {
                setEntityTypeIdOwmer([changeValue]);
            }

            //functions entity tin/pin
            globalFunctions.entityTinPin(idFieldTable, data, itemDoc, field, setField, changeValue);

            //entity argRpcRegNumber
            globalFunctions.entityArgRpcRegNumber(idFieldTable, data, itemDoc, field, setField, changeValue, id);

            //addressBook isDefault
            if (nameGroup && group[nameGroup] && !nameGroup.includes('entityBankAccount')) {
                console.log('ingresa***')
                globalFunctions.addressBook(idFieldTable, field, setField, changeValue, id, group, nameGroup, indexGroup, info, nameSubGroup, indexSubGroup);
                globalFunctions.entityTinPinGroup(idFieldTable, field, setField, changeValue, group, nameGroup);
            }
            //Perfil Inversor
            if (e !== null && itemDoc.entityDocId === '7') {
                globalFunctions.calcularPerfilInversor(id, changeValue, data, field, investorProfile, setField);
            }
            //REQUEST CODE
            globalFunctions.requestCode(idFieldTable, setRequestCode, data, changeValue, setField);
        }
    };


    const handlePucOrderCuitChange = (responsePUC, responseORDER, itemDoc, nameGroup, index, uifsro) => {
        setField(prevState => ({
            ...prevState,
            '1_1_23': false
        }), []);
        let uifsroFlag = uifsro;
        if (responsePUC) {
            setPuc(responsePUC.data);

            if (uifsro) {
                if (uifsro.data.length === 0) {
                    uifsro.data.push({ 'mensaje': 'No hay coincidencias para el CUIT solicitado', 'Ejecución': new Date() })
                }
                uifsro.data[0].Ejecución = new Date();
                setUifsro(uifsro.data);
                uifsroFlag = uifsro.data;
            }
        }

        if (responseORDER) {
            if (responseORDER.data) {
                setField(prevState => ({
                    ...prevState,
                    '1_1_23': true
                }), []);
                setOrder(responseORDER.data);
            }
        }

        if (responsePUC !== null) {
            pucValues(responsePUC.data, nameGroup, entityDocId, index, uifsroFlag, itemDoc, setField, setEntityTypeIdOwmer, setCantidadCondoApod, cantidadCondoApod, info, data, group, addElementGroup, setEntityPropIdOwner);
        }
    }


    const searchOrder = () => {

        //LEVANTA LOS DATOS DE LA ÓRDEN

        //setGroup(initialArrayGroup(data));
        if (order) {
            //setDocIdSave(order.order.length)
            let arrayData = [];
            let cantidadCondominiosOrder = 0;
            for (let r = 0; r < data.length; r++) {
                //data[r].id = Number(data[r].id) + 1000;
                data[r].id = Number(data[r].id);
                if (data[r].entityDocId !== '1') {
                    let existe = false;
                    let existeOrder = false;
                    for (let u = 0; u < order.order.length; u++) {
                        if (Number(order.order[u].entityDocId) === Number(data[r].entityDocId)) {

                            for (let y = 0; y < order.order[u].boxes.length; y++) {

                                for (let d = 0; d < order.order[u].boxes[y].fields.length; d++) {
                                    if (order.order[u].boxes[y].fields[d].idFieldTable === 'status') {
                                        if (order.order[u].boxes[y].fields[d].value === '' || order.order[u].boxes[y].fields[d].value.toUpperCase() === 'EN CURSO') {
                                            existeOrder = true;
                                        }
                                    }
                                }
                            }

                            if (existeOrder === true) {

                                if (order.order[u].entityDocId === '2')
                                    cantidadCondominiosOrder++;

                                for (let y = 0; y < order.order[u].boxes.length; y++) {

                                    for (let d = 0; d < order.order[u].boxes[y].fields.length; d++) {

                                        if (order.order[u].boxes[y].fields[d].defaultValue === 'entityIx()' && order.order[u].boxes[y].fields[d].value) {
                                            order.order[u].entityIx = order.order[u].boxes[y].fields[d].value;
                                        }

                                        if (order.order[u].boxes[y].fields[d].group === null) {
                                            let idField = order.order[u].boxes[y].fields[d].id;
                                            if (order.order[u].boxes[y].fields[d].id.split('_').length === 1)
                                                idField = `${order.order[u].entityDocId}_${order.order[u].id}_${order.order[u].boxes[y].fields[d].id}`

                                            switch (order.order[u].boxes[y].fields[d].type) {
                                                case 'Select':

                                                    let existe = false;

                                                    info.forEach((itemInfo) => {
                                                        if (itemInfo.source === order.order[u].boxes[y].fields[d].sourceSelect) {
                                                            if (Number(order.order[u].boxes[y].fields[d].value) === Number(itemInfo.id)) {
                                                                existe = true;
                                                                setField(prevState => ({
                                                                    ...prevState,
                                                                    [idField]: {
                                                                        id: itemInfo.id,
                                                                        label: itemInfo.nameAlt !== undefined ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                                                                    }
                                                                }), []);
                                                            }
                                                        }
                                                    })
                                                    if (existe === false) {
                                                        setField(prevState => ({
                                                            ...prevState,
                                                            [idField]: null
                                                        }), []);
                                                    }
                                                    break;
                                                case 'Checkbox':
                                                    setField(prevState => ({
                                                        ...prevState,
                                                        [idField]: false
                                                    }));
                                                    if (order.order[u].boxes[y].fields[d].value === 'true') {
                                                        setField(prevState => ({
                                                            ...prevState,
                                                            [idField]: true
                                                        }));
                                                    }
                                                    break;
                                                case 'Switch':
                                                    setField(prevState => ({
                                                        ...prevState,
                                                        [idField]: false
                                                    }));
                                                    if (order.order[u].boxes[y].fields[d].value === 'true') {
                                                        setField(prevState => ({
                                                            ...prevState,
                                                            [idField]: true
                                                        }));
                                                    }
                                                    break;
                                                default:
                                                    setField(prevState => ({
                                                        ...prevState,
                                                        [idField]: order.order[u].boxes[y].fields[d].value
                                                    }));
                                                    break;
                                            }

                                        } else {
                                            let nameGroup;
                                            let arrayGroupObjects = [];
                                            for (let n = 0; n < order.order[u].boxes[y].fields[d].group.length; n++) {

                                                nameGroup = `${order.order[u].entityDocId}_${order.order[u].id}_${order.order[u].boxes[y].fields[d].group[n].name}`;

                                                let objArrayElement = JSON.parse(JSON.stringify(order.order[u].boxes[y].fields[d].group[n]));
                                                for (let m = 0; m < objArrayElement.fields.length; m++) {
                                                    objArrayElement.fields[m].isGroup = true;
                                                }
                                                for (let m = 0; m < order.order[u].boxes[y].fields[d].group[n].fields.length; m++) {

                                                    if (order.order[u].boxes[y].fields[d].group[n].fields[m].subGroup !== null) {
                                                        //SUBGROUP
                                                        let arraySubGroupObjects = [];
                                                        for (let e = 0; e < order.order[u].boxes[y].fields[d].group[n].fields[m].subGroup.length; e++) {

                                                            let objArrayElementSubgroup = JSON.parse(JSON.stringify(order.order[u].boxes[y].fields[d].group[n].fields[m].subGroup[e]));
                                                            for (let m = 0; m < objArrayElementSubgroup.fields.length; m++) {
                                                                objArrayElementSubgroup.fields[m].isGroup = true;
                                                            }

                                                            for (let k = 0; k < order.order[u].boxes[y].fields[d].group[n].fields[m].subGroup[e].fields.length; k++) {

                                                                let idField = order.order[u].boxes[y].fields[d].group[n].fields[m].subGroup[e].fields[k].id;
                                                                if (order.order[u].boxes[y].fields[d].group[n].fields[m].subGroup[e].fields[k].id.split('_').length === 1)
                                                                    idField = `${order.order[u].entityDocId}_${order.order[u].id}_${order.order[u].boxes[y].fields[d].group[n].fields[m].subGroup[e].fields[k].id}`

                                                                if (order.order[u].boxes[y].fields[d].group[n].fields[m].subGroup[e].fields[k].type) {
                                                                    switch (order.order[u].boxes[y].fields[d].group[n].fields[m].subGroup[e].fields[k].type) {
                                                                        case 'Select':
                                                                            let existe = false;
                                                                            info.forEach((itemInfo) => {
                                                                                if (itemInfo.source === order.order[u].boxes[y].fields[d].group[n].fields[m].subGroup[e].fields[k].sourceSelect) {
                                                                                    if (Number(order.order[u].boxes[y].fields[d].group[n].fields[m].subGroup[e].fields[k].value) === Number(itemInfo.id)) {
                                                                                        existe = true;
                                                                                        setField(prevState => ({
                                                                                            ...prevState,
                                                                                            [idField]: {
                                                                                                id: itemInfo.id,
                                                                                                label: itemInfo.nameAlt !== undefined ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                                                                                            }
                                                                                        }), []);
                                                                                    }
                                                                                }
                                                                            })
                                                                            if (existe === false) {
                                                                                setField(prevState => ({
                                                                                    ...prevState,
                                                                                    [idField]: null
                                                                                }), []);
                                                                            }
                                                                            break;
                                                                        case 'Checkbox':
                                                                            setField(prevState => ({
                                                                                ...prevState,
                                                                                [idField]: false
                                                                            }));
                                                                            if (order.order[u].boxes[y].fields[d].group[n].fields[m].subGroup[e].fields[k].value === 'true') {
                                                                                setField(prevState => ({
                                                                                    ...prevState,
                                                                                    [idField]: true
                                                                                }));
                                                                            }
                                                                            break;
                                                                        case 'Switch':
                                                                            setField(prevState => ({
                                                                                ...prevState,
                                                                                [idField]: false
                                                                            }));
                                                                            if (order.order[u].boxes[y].fields[d].group[n].fields[m].subGroup[e].fields[k].value === 'true') {
                                                                                setField(prevState => ({
                                                                                    ...prevState,
                                                                                    [idField]: true
                                                                                }));
                                                                            }
                                                                            else {
                                                                                setField(prevState => ({
                                                                                    ...prevState,
                                                                                    [idField]: true
                                                                                }));
                                                                            }
                                                                            break;
                                                                        default:

                                                                            let value = order.order[u].boxes[y].fields[d].group[n].fields[m].subGroup[e].fields[k].value;
                                                                            setField(prevState => ({
                                                                                ...prevState,
                                                                                [idField]: value
                                                                            }));

                                                                            break;
                                                                    }
                                                                }
                                                            }
                                                            if (e !== 0) {
                                                                arraySubGroupObjects.push(objArrayElementSubgroup)
                                                            }
                                                        }
                                                        objArrayElement.subGroup = arraySubGroupObjects;
                                                    } else {
                                                        let idField = order.order[u].boxes[y].fields[d].group[n].fields[m].id;
                                                        if (order.order[u].boxes[y].fields[d].group[n].fields[m].id.split('_').length === 1)
                                                            idField = `${order.order[u].entityDocId}_${order.order[u].id}_${order.order[u].boxes[y].fields[d].group[n].fields[m].id}`

                                                        switch (order.order[u].boxes[y].fields[d].group[n].fields[m].type) {
                                                            case 'Select':
                                                                let existe = false;
                                                                info.forEach((itemInfo) => {
                                                                    if (itemInfo.source === order.order[u].boxes[y].fields[d].group[n].fields[m].sourceSelect) {
                                                                        if (Number(order.order[u].boxes[y].fields[d].group[n].fields[m].value) === Number(itemInfo.id)) {
                                                                            existe = true;
                                                                            setField(prevState => ({
                                                                                ...prevState,
                                                                                [idField]: {
                                                                                    id: itemInfo.id,
                                                                                    label: itemInfo.nameAlt !== undefined ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                                                                                }
                                                                            }), []);
                                                                        }
                                                                    }
                                                                })
                                                                if (existe === false) {
                                                                    setField(prevState => ({
                                                                        ...prevState,
                                                                        [idField]: null
                                                                    }), []);
                                                                }
                                                                break;
                                                            case 'Checkbox':
                                                                setField(prevState => ({
                                                                    ...prevState,
                                                                    [idField]: false
                                                                }));
                                                                if (order.order[u].boxes[y].fields[d].group[n].fields[m].value === 'true') {
                                                                    setField(prevState => ({
                                                                        ...prevState,
                                                                        [idField]: true
                                                                    }));
                                                                }
                                                                break;
                                                            case 'Switch':
                                                                setField(prevState => ({
                                                                    ...prevState,
                                                                    [idField]: false
                                                                }));
                                                                if (order.order[u].boxes[y].fields[d].group[n].fields[m].value === 'true') {
                                                                    setField(prevState => ({
                                                                        ...prevState,
                                                                        [idField]: true
                                                                    }));
                                                                }
                                                                else {
                                                                    setField(prevState => ({
                                                                        ...prevState,
                                                                        [idField]: false
                                                                    }));
                                                                }
                                                                break;
                                                            default:
                                                                setField(prevState => ({
                                                                    ...prevState,
                                                                    [idField]: order.order[u].boxes[y].fields[d].group[n].fields[m].value
                                                                }));
                                                                break;
                                                        }
                                                    }
                                                }
                                                if (n !== 0) {
                                                    arrayGroupObjects.push(objArrayElement)
                                                }
                                                if (n === 0 && order.order[u].condominoApoderado === true) {
                                                    arrayGroupObjects.push(objArrayElement);
                                                }
                                                if (group[nameGroup] === undefined && order.order[u].condominoApoderado === false && n === 0) {
                                                    arrayGroupObjects.push(objArrayElement);
                                                }
                                            }

                                            if (arrayGroupObjects.length > 0) {

                                                if (group[nameGroup]) {
                                                    setGroup(prevState => ({
                                                        ...prevState,
                                                        [nameGroup]: [...prevState[nameGroup], ...arrayGroupObjects]
                                                    }));
                                                }
                                                else {
                                                    setGroup(prevState => ({
                                                        ...prevState,
                                                        [nameGroup]: arrayGroupObjects
                                                    }));
                                                }
                                            }
                                        }
                                    }
                                }

                                order.order[u].orderFirestore = true;
                                arrayData.push(order.order[u]);
                                existe = true
                            }
                        }
                    }

                    //if (existe === false && existeOrder === true) {
                    if (existe === false) {
                        arrayData.push(data[r]);
                    }
                } else {
                    arrayData.push(data[r]);
                }
            }
            cantidadCondominiosOrder--;
            setCantidadCondoApod(cantidadCondoApod + cantidadCondominiosOrder)
            setData(arrayData);
            setInitialData(arrayData);
        }
    }


    const addScreen = (data, entity, flag) => {
        screen.addScreen(data, entity, setField, entityDocId, entityTypeIdOwner, group, field, setGroup, dataDocumentation, info, setData, flag, requestCode)
    }

    const onDeleteElementGroup = (index, group1) => {
        let arrayFlag = [];
        for (let i = 0; i < group[group1].length; i++) {
            if (Number(i) !== Number(index)) {
                arrayFlag.push(group[group1][i]);
            }
        }
        setGroup(prevState => ({
            ...prevState,
            [group1]: arrayFlag
        }));
    }

    const onDeleteElementSubGroup = (index, nameSubGroup, nameGroup, id, indexGroup, entityDocId) => {

        data.forEach((itemData) => {
            if (itemData.id === id) {
                nameGroup = `${entityDocId}_${itemData.id}_${nameGroup}`
            }
        })
        // Clonar el objeto 'group' para evitar mutar el estado directamente
        const groupActualizado = { ...group };

        // Encontrar el índice del objeto 'subGroup_4_Domicilios' en el array

        const subGroupDomiciliosIndice = groupActualizado[nameGroup][indexGroup].subGroup.findIndex(
            (subGroup) => nameSubGroup in subGroup
        );

        if (subGroupDomiciliosIndice !== -1) {
            // Clonar el array de 'subGroup_4_Domicilios' para evitar mutar el estado directamente
            const subGroupDomiciliosActualizado = [
                ...groupActualizado[nameGroup][indexGroup].subGroup[subGroupDomiciliosIndice][nameSubGroup],
            ];

            // Verificar si el índice del elemento a eliminar es válido
            if (index >= 0 && index < subGroupDomiciliosActualizado.length) {
                // Eliminar el elemento del array 'subGroup_4_Domicilios' en el índice especificado
                subGroupDomiciliosActualizado.splice(index, 1);

                // Actualizar el array 'subGroup_4_Domicilios' en el objeto 'group'
                groupActualizado[nameGroup][indexGroup].subGroup[subGroupDomiciliosIndice][nameSubGroup] = subGroupDomiciliosActualizado;

                // Setear el objeto actualizado en el hook 'group'
                setGroup(groupActualizado);
            } else {
                console.error("Índice de elemento a eliminar fuera de rango.");
            }
        } else {
            console.error("No se encontró el subGroup_4_Domicilios en el objeto.");
        }
    }

    const addElementSubGroup = (group1, id, nameSubGroup, indexGroup, indexItemSubGroupFields, object, newArray, idAdjunto) => {
        groupFunctions.addElementSubGroup(group1, id, nameSubGroup, indexGroup, indexItemSubGroupFields, data, info, setField, group, setGroup, object, newArray, idAdjunto, dataDocumentation)
    }

    const addElementGroup = (group1, id, orderMemoryFlag, newArray, entityDocId) => {
        groupFunctions.addElementGroup(group1, id, orderMemoryFlag, newArray, entityDocId, data, info, setField, group, setGroup);
    }

    /*const validateFieldsGroup = (group1) => {
        let validate = true;
        data.forEach((itemData) => {
            itemData.boxes.forEach((itemBoxs) => {
                itemBoxs.fields.forEach((itemFields) => {
                    if (itemFields.group !== null) {
                        itemFields.group.forEach((itemGroup) => {
                            if (itemGroup.name === group1) {
                                itemGroup.fields.forEach((item) => {
                                    //let idField = itemData.entityDocId + item.id;
                                    let entityDocFlag = itemData.entityDocId;
                                    if (itemData.entityDocId.length > 1) {
                                        entityDocFlag = `${itemData.entityDocId[0]}_${itemData.entityDocId[1]}`
                                    }
                                    let idField = entityDocFlag + item.id;

                                    let value = field[idField];
                                    let view = true;
                                    if (item.where !== null) {
                                        view = whereFunctions.whereFunction(item, itemData.entityDocId);
                                    }

                                    if (item.view === 'edit' && view === true && item.mandatory === true && (value === undefined || !value)) {
                                        validate = false;
                                    }
                                })
                            }
                        })
                    }
                })
            })
        })
        return validate;
    }*/

    const searchOptions = (itemField, nameGroup, entityDocId, dataSource, id) => {

        if (nameGroup)
            nameGroup = nameGroup.split('_')[2];

        let idField;
        let idFieldT;

        if (dataSource !== null) {

            data.forEach((itemData) => {
                if (Number(itemData.id) === Number(id) && Number(itemData.entityDocId) === Number(entityDocId)) {
                    itemData.boxes.forEach((itemBoxes) => {
                        itemBoxes.fields.forEach((itemFields) => {
                            if (itemFields.group !== null) {
                                itemFields.group.forEach((itemGroup) => {
                                    itemGroup.fields.forEach((itemGroupFields) => {


                                        if (Number(itemGroupFields.id) === Number(dataSource)) {

                                            idField = `${itemData.entityDocId}_${itemData.id}_${itemGroupFields.id}`

                                            idFieldT = itemGroupFields.idFieldTable;
                                        }
                                    })
                                })
                            } else {

                                if (Number(itemFields.id) === Number(dataSource)) {


                                    idField = `${itemData.entityDocId}_${itemData.id}_${itemFields.id}`

                                    idFieldT = itemFields.idFieldTable;
                                }
                            }
                        })
                    })
                }
            })
        }

        let options = [];
        info.forEach((itemInfo) => {
            if (itemField.sourceSelectDoc !== null) {
                itemField.sourceSelectDoc.forEach((itemSourceSelectDoc) => {

                    if (itemInfo.source === itemField.sourceSelect && !nameGroup && itemInfo.doc === itemSourceSelectDoc) {
                        if (dataSource === null || dataSource === undefined)
                            options.push({
                                id: itemInfo.id,
                                label: itemInfo.nameAlt !== undefined ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                                isInactive: itemInfo.isInactive,
                            })
                        else {
                            if (field[idField] || field[idField] === 0) {
                                if (typeof field[idField] === 'object') {
                                    if (Number(field[idField].id) === Number(itemInfo[idFieldT])) {
                                        options.push({
                                            id: itemInfo.id,
                                            label: itemInfo.nameAlt !== undefined ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                                            isInactive: itemInfo.isInactive,
                                        })
                                    }
                                } else {
                                    if (field[idField].toString() === itemInfo[idFieldT].toString()) {
                                        options.push({
                                            id: itemInfo.id,
                                            label: itemInfo.nameAlt !== undefined ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                                            isInactive: itemInfo.isInactive,
                                        })
                                    }
                                }
                            }
                        }

                    } else {
                        if (itemInfo.source === itemField.sourceSelect && nameGroup === itemInfo.group && itemInfo.doc === itemSourceSelectDoc) {
                            if (dataSource === null || dataSource === undefined) {
                                options.push({
                                    id: itemInfo.id,
                                    label: itemInfo.nameAlt !== undefined ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                                    isInactive: itemInfo.isInactive,
                                })
                            }
                            else {
                                if (field[idField] || field[idField] === 0) {
                                    if (typeof field[idField] === 'object') {
                                        if (Number(field[idField].id) === Number(itemInfo[idFieldT])) {
                                            options.push({
                                                id: itemInfo.id,
                                                label: itemInfo.nameAlt !== undefined ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                                                isInactive: itemInfo.isInactive,
                                            })
                                        }
                                    } else {
                                        if (field[idField].toString() === itemInfo[idFieldT].toString()) {
                                            options.push({
                                                id: itemInfo.id,
                                                label: itemInfo.nameAlt !== undefined ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                                                isInactive: itemInfo.isInactive,
                                            })
                                        }
                                    }
                                }
                            }
                        } else {
                            if (itemInfo.source === itemField.sourceSelect && nameGroup && !itemInfo.group && itemInfo.doc === itemSourceSelectDoc) {
                                if (dataSource === null || dataSource === undefined) {
                                    options.push({
                                        id: itemInfo.id,
                                        label: itemInfo.nameAlt !== undefined ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                                        isInactive: itemInfo.isInactive,
                                    })
                                }
                                else {
                                    if (field[idField] || field[idField] === 0) {
                                        if (typeof field[idField] === 'object') {
                                            if (Number(field[idField].id) === Number(itemInfo[idFieldT])) {
                                                options.push({
                                                    id: itemInfo.id,
                                                    label: itemInfo.nameAlt !== undefined ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                                                    isInactive: itemInfo.isInactive,

                                                })
                                            }
                                        } else {
                                            if (field[idField].toString() === itemInfo[idFieldT].toString()) {
                                                options.push({
                                                    id: itemInfo.id,
                                                    label: itemInfo.nameAlt !== undefined ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                                                    isInactive: itemInfo.isInactive,
                                                })
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                })

            } else {

                if (itemInfo.source === itemField.sourceSelect && !nameGroup) {
                    if (dataSource === null || dataSource === undefined) {
                        options.push({
                            id: itemInfo.id,
                            label: itemInfo.nameAlt !== undefined ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                            isInactive: itemInfo.isInactive,
                        })
                    }
                    else {
                        if (field[idField] || field[idField] === 0) {
                            if (typeof field[idField] === 'object') {
                                if (Number(field[idField].id) === Number(itemInfo[idFieldT])) {
                                    options.push({
                                        id: itemInfo.id,
                                        label: itemInfo.nameAlt !== undefined ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                                        isInactive: itemInfo.isInactive,
                                    })
                                }
                            } else {
                                if (field[idField].toString() === itemInfo[idFieldT].toString()) {
                                    options.push({
                                        id: itemInfo.id,
                                        label: itemInfo.nameAlt !== undefined ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                                        isInactive: itemInfo.isInactive,
                                    })
                                }
                            }
                        }
                    }

                } else {
                    if (itemInfo.source === itemField.sourceSelect && nameGroup === itemInfo.group) {
                        if (dataSource === null || dataSource === undefined) {

                            options.push({
                                id: itemInfo.id,
                                label: itemInfo.nameAlt !== undefined ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                                isInactive: itemInfo.isInactive,
                            })
                        }
                        else {
                            if (field[idField] || field[idField] === 0) {
                                if (typeof field[idField] === 'object') {
                                    if (Number(field[idField].id) === Number(itemInfo[idFieldT])) {
                                        options.push({
                                            id: itemInfo.id,
                                            label: itemInfo.nameAlt !== undefined ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                                            isInactive: itemInfo.isInactive,
                                        })
                                    }
                                } else {
                                    if (field[idField].toString() === itemInfo[idFieldT].toString()) {
                                        options.push({
                                            id: itemInfo.id,
                                            label: itemInfo.nameAlt !== undefined ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                                            isInactive: itemInfo.isInactive,
                                        })
                                    }
                                }
                            }
                        }
                    } else {
                        if (itemInfo.source === itemField.sourceSelect && nameGroup && !itemInfo.group) {
                            if (dataSource === null || dataSource === undefined) {
                                options.push({
                                    id: itemInfo.id,
                                    label: itemInfo.nameAlt !== undefined ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                                    isInactive: itemInfo.isInactive,
                                })
                            }
                            else {
                                if (field[idField] || field[idField] === 0) {
                                    if (typeof field[idField] === 'object') {
                                        if (Number(field[idField].id) === Number(itemInfo[idFieldT])) {
                                            options.push({
                                                id: itemInfo.id,
                                                label: itemInfo.nameAlt !== undefined ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                                                isInactive: itemInfo.isInactive,
                                            })
                                        }
                                    } else {
                                        if (field[idField].toString() === itemInfo[idFieldT].toString()) {
                                            options.push({
                                                id: itemInfo.id,
                                                label: itemInfo.nameAlt !== undefined ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                                                isInactive: itemInfo.isInactive,
                                            })
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        })
        return options;
    }

    const formatListNumber = (e) => {

    }

    const renderFields = (itemField, indexField, itemDoc, arrayDoc, itemBoxs, nameGroup, indexGroup, viewFieldFlag, subGroup, nameSubGroup, indexSubGroup) => {

        if (itemField.view !== 'hidden' && itemField.type !== null) {
            let view = true;
            if (itemField.where !== null && itemField.where !== undefined) {
                view = whereFunctions.whereFunction(itemField, field, itemDoc);
            }

            if (view === true) {
                let idField = `${itemDoc.entityDocId}_${itemDoc.id}_${itemField.id}`;
                if (itemField.id) {
                    if (itemField.id.split("_").length > 1) {
                        idField = itemField.id;
                    }
                }
                if (viewFieldFlag === false) {
                    if (subGroup === true) {
                        arrayDoc.push(<LabelIcon style={{ marginLeft: '25px', fontSize: '20px' }} color="primary" />);
                    } else {
                        arrayDoc.push(<LabelIcon style={{ fontSize: '20px' }} color="primary" />);
                    }
                }

                let nameField = itemField.name;
                if (itemField.mandatory)
                    nameField = `${nameField} *`

                if ((idField === '4_4_13' || idField === '4_4_17' || idField === '4_4_19') && field[idField]) {
                    itemField.type = 'Typography';
                    itemField.defaultValue = field[idField].label
                    if (idField === '4_4_19')
                        itemField.defaultValue = field[idField]
                }

                switch (itemField.type) {
                    case 'Percentage':
                        arrayDoc.push(
                            <div idfield={idField} className="mi-componente-material-ui">
                                <Grid container sx={{ m: 1 }} xs={12} item>
                                    <Grid item>
                                        <PercentageComponente
                                            maxLength={itemField.maxLenght}
                                            disabled={itemField.view === 'viewOnly' ? true : false}
                                            id={idField}
                                            name={nameField}
                                            value={field[idField]}
                                            onChange={(event) => handleFieldChange(event, null, idField, itemField.idFieldTable, itemDoc, nameGroup, indexGroup, nameSubGroup, indexSubGroup)}
                                            itemFunction={itemField.function}
                                            //onBlur={(dataPUC, dataOrder, uifsro) => handlePucOrderCuitChange(dataPUC, dataOrder, idField, itemDoc.id, nameGroup, indexGroup, uifsro, itemField.idFieldTable, itemDoc.entityDocId, itemDoc)}
                                            user={user}
                                            instance={instance}
                                            help={itemField.help}
                                            onLoadingChange={handleLoadingChange}
                                            //mandatory={itemField.mandatory}
                                            error={error[idField]}
                                            errorHelpText={helpText[idField]}
                                            onValidationField={onValidationField}
                                            entityDocId={itemDoc.entityDocId}
                                            mode={false}
                                            className={itemField.print === false ? constant.HIDE_IN_PRINT_CLASS : null}
                                        />
                                    </Grid>
                                </Grid>
                            </div>)
                        break;
                    case 'File':
                        arrayDoc.push(
                            <div style={{ display: 'inline-block', margin: '0 0.2px' }}>
                                <Grid container xs={12} item>
                                    <Grid item>
                                        <FileComponent
                                            className={itemField.print === false ? constant.HIDE_IN_PRINT_CLASS : null}
                                            onChange={(event) => handleFieldChange(event, null, idField, itemField.idFieldTable, itemDoc, nameGroup, indexGroup, nameSubGroup, indexSubGroup)}
                                            onValidationField={onValidationField}
                                            //mandatory={itemField.mandatory}
                                            help={itemField.help}
                                            id={idField}
                                        />
                                    </Grid>
                                </Grid>
                            </div>
                        );
                        break;
                    case 'TextField':
                        arrayDoc.push(
                            <div idfield={idField} className="mi-componente-material-ui">
                                <Grid container sx={{ m: 1 }} xs={12} item >
                                    <Grid item>
                                        <TextFieldComponent
                                            maxLength={itemField.maxLenght}
                                            disabled={itemField.view === 'viewOnly' ? true : false}
                                            id={idField}
                                            name={nameField}
                                            value={field[idField]}
                                            onChange={(event) => handleFieldChange(event, null, idField, itemField.idFieldTable, itemDoc, nameGroup, indexGroup, nameSubGroup, indexSubGroup)}
                                            itemFunction={itemField.function}
                                            onBlur={(dataPUC, dataOrder, uifsro) => handlePucOrderCuitChange(dataPUC, dataOrder, itemDoc, nameGroup, indexGroup, uifsro)}
                                            user={user}
                                            instance={instance}
                                            help={itemField.help}
                                            onLoadingChange={handleLoadingChange}
                                            error={error[idField]}
                                            errorHelpText={helpText[idField]}
                                            onValidationField={onValidationField}
                                            entityDocId={itemDoc.entityDocId}
                                            mode={false}
                                            className={itemField.print === false ? constant.HIDE_IN_PRINT_CLASS : null}
                                            email={email}
                                            cuit={cuit}
                                            heightParam={null}
                                            widthParam={null}
                                            minWidthParam={null}
                                        />
                                    </Grid>
                                </Grid>
                            </div>)
                        break;
                    case 'Select':


                        let options = searchOptions(itemField, nameGroup, itemDoc.entityDocId, itemField.dataSource, itemDoc.id);

                        if (idField === '11_11_18' || idField === '4_4_14' || idField === '12_12_18' || idField === '1_413_18' || (itemField.name === 'Apoderado' && itemField.idFieldTable === null)) {

                            for (let r = 0; r < entity.length; r++) {
                                let ph = false;
                                let entityProp;
                                let idEntity = entity[r].idEntity;
                                let fullName;
                                for (let b = 0; b < entity[r].boxes.length; b++) {

                                    for (let a = 0; a < entity[r].boxes[b].fields.length; a++) {
                                        if (entity[r].boxes[b].fields[a].idFieldTable === 'entityTypeId') {
                                            if (entity[r].boxes[b].fields[a].value) {
                                                if (Number(entity[r].boxes[b].fields[a].value.id) === 1) {
                                                    ph = true;
                                                }
                                            }
                                        }
                                        if (entity[r].boxes[b].fields[a].idFieldTable === 'entityPropId') {
                                            if (entity[r].boxes[b].fields[a].value) {
                                                if (Number(entity[r].boxes[b].fields[a].value.id) === 1 || Number(entity[r].boxes[b].fields[a].value.id) === 2 || Number(entity[r].boxes[b].fields[a].value.id) === 3) {
                                                    entityProp = true;
                                                }
                                            }
                                        }
                                        if (entity[r].boxes[b].fields[a].idFieldTable === 'fullName') {
                                            fullName = entity[r].boxes[b].fields[a].value;
                                        }
                                    }

                                }
                                if (ph === true && entityProp === true) {

                                    options.push({
                                        id: idEntity,
                                        label: fullName
                                    })
                                }
                            }
                        }


                        arrayDoc.push(
                            <div idfield={idField} className="mi-componente-material-ui">
                                <Grid container sx={{ m: 1 }} xs={12} item>
                                    <Grid xs={3} item>
                                        <SelectComponent
                                            disabled={itemField.view === 'viewOnly' ? true : false}
                                            id={idField}
                                            name={nameField}
                                            value={field[idField]}
                                            onChange={(event, newValue) => handleFieldChange(event, newValue, idField, itemField.idFieldTable, itemDoc, nameGroup, indexGroup, nameSubGroup, indexSubGroup)}
                                            help={itemField.help}
                                            options={options}
                                            mode={false}
                                            className={itemField.print === false ? constant.HIDE_IN_PRINT_CLASS : null}
                                            onBlur={(event) => formatListNumber(event)}
                                        />
                                    </Grid>
                                </Grid>
                            </div>)
                        break;

                    case 'Typography':
                        let paragraphType = 'body1';
                        let fontSize = '0.7rem';
                        if (itemField.cssClass === 'titleStyle4') {
                            paragraphType = 'h4';
                            fontSize = null;
                            fontSize = '1rem';
                        }

                        arrayDoc.push(
                            <div style={{ display: 'inline-block', margin: '0 0.2px' }}>
                                <Grid container sx={{ m: 1 }} xs={12} style={{ marginTop: '0px', marginBottom: '0px', marginRight: '8px', marginLeft: '8px' }} item>
                                    <Grid item>
                                        <TypographyComponent
                                            paragraphType={paragraphType}
                                            text={itemField.defaultValue}
                                            className={itemField.print === false ? constant.HIDE_IN_PRINT_CLASS : null}
                                            style={{ fontSize: fontSize }}
                                        />

                                    </Grid>
                                </Grid>
                            </div>
                        );

                        break;
                    case 'Json':
                        arrayDoc.push(
                            //<div style={{ display: 'inline-block' }}>
                            <div idfield={idField} className="mi-componente-material-ui">
                                <Grid container sx={{ m: 1 }} xs={12} item>
                                    <Grid item>
                                        <JsonComponent
                                            maxLength={itemField.maxLenght}
                                            disabled={itemField.view === 'viewOnly' ? true : false}
                                            id={idField}
                                            name={nameField}
                                            value={field[idField]}
                                            onChange={(event) => handleFieldChange(event, null, idField, itemField.idFieldTable, itemDoc, nameGroup, indexGroup, nameSubGroup, indexSubGroup)}
                                            itemFunction={itemField.function}
                                            //onBlur={(dataPUC, dataOrder) => handlePucOrderCuitChange(dataPUC, dataOrder, idField, itemDoc.id, nameGroup, indexGroup, uifsro, itemField.idFieldTable, itemDoc.entityDocId, itemDoc)}
                                            user={user}
                                            instance={instance}
                                            help={itemField.help}
                                            onLoadingChange={handleLoadingChange}
                                            //mandatory={itemField.mandatory}
                                            error={error[idField]}
                                            errorHelpText={helpText[idField]}
                                            onValidationField={onValidationField}
                                            entityDocId={itemDoc.entityDocId}
                                            mode={false}
                                            className={itemField.print === false ? constant.HIDE_IN_PRINT_CLASS : null}
                                        />
                                    </Grid>
                                </Grid>
                            </div>)
                        break;
                    case 'Number':
                        arrayDoc.push(
                            //<div style={{ display: 'inline-block', margin: '0 0.2px' }}>
                            <div idfield={idField} className="mi-componente-material-ui">
                                <Grid container sx={{ m: 1 }} xs={12} item>
                                    <Grid item>
                                        <NumberComponent
                                            maxLength={itemField.maxLenght}
                                            disabled={itemField.view === 'viewOnly' ? true : false}
                                            id={idField}
                                            name={nameField}
                                            value={field[idField]}
                                            onChange={(event) => handleFieldChange(event, null, idField, itemField.idFieldTable, itemDoc, nameGroup, indexGroup, nameSubGroup, indexSubGroup)}
                                            itemFunction={itemField.function}
                                            help={itemField.help}
                                            mode={false}
                                            className={itemField.print === false ? constant.HIDE_IN_PRINT_CLASS : null}
                                        />
                                    </Grid>
                                </Grid>
                            </div>)
                        break;
                    case 'Currency':
                        arrayDoc.push(
                            //<div style={{ display: 'inline-block', margin: '0 0.2px' }}>
                            <div idfield={idField} className="mi-componente-material-ui">
                                <Grid container sx={{ m: 1 }} xs={12} item>
                                    <Grid item>
                                        <CurrencyComponent
                                            maxLength={itemField.maxLenght}
                                            disabled={itemField.view === 'viewOnly' ? true : false}
                                            id={idField}
                                            name={nameField}
                                            value={field[idField]}
                                            onChange={(event) => handleFieldChange(event, null, idField, itemField.idFieldTable, itemDoc, nameGroup, indexGroup, nameSubGroup, indexSubGroup)}
                                            itemFunction={itemField.function}
                                            help={itemField.help}
                                            mode={false}
                                            className={itemField.print === false ? constant.HIDE_IN_PRINT_CLASS : null}
                                        />
                                    </Grid>
                                </Grid>
                            </div>)
                        break;
                    case 'Checkbox':

                        let valueCheckbox = field[idField];
                        if (valueCheckbox === '0')
                            valueCheckbox = false;

                        arrayDoc.push(
                            // <div style={{ display: 'inline-block', margin: '0 0.2px' }}>
                            <div className="mi-componente-material-ui">
                                <Grid container sx={{ m: 1 }} xs={12} item>
                                    <Grid xs={12} item>
                                        <CheckBoxComponent
                                            disabled={itemField.view === 'viewOnly' ? true : false}
                                            id={idField}
                                            name={nameField}
                                            value={valueCheckbox}
                                            onChange={(event) => handleFieldChange(event, null, idField, itemField.idFieldTable, itemDoc, nameGroup, indexGroup, nameSubGroup, indexSubGroup)}
                                            help={itemField.help}
                                            mode={false}
                                            className={itemField.print === false ? constant.HIDE_IN_PRINT_CLASS : null}
                                        />
                                    </Grid>
                                </Grid>
                            </div>)
                        break;
                    case 'Switch':
                        let valueSwitch = field[idField];
                        if (valueSwitch === '0')
                            valueSwitch = false;
                        arrayDoc.push(
                            //<div style={{ display: 'inline-block', margin: '0 0.2px' }}>
                            <div className="mi-componente-material-ui">
                                <Grid container sx={{ m: 1 }} xs={12} item>
                                    <Grid xs={8} item>
                                        <SwitchComponent
                                            disabled={itemField.view === 'viewOnly' ? true : false}
                                            id={idField}
                                            name={nameField}
                                            value={valueSwitch}
                                            onChange={(event) => handleFieldChange(event, null, idField, itemField.idFieldTable, itemDoc, nameGroup, indexGroup, nameSubGroup, indexSubGroup)}
                                            help={itemField.help}
                                            mode={false}
                                            //className={itemField.print === false ? constant.HIDE_IN_PRINT_CLASS : null}
                                            classNameNoWrap="noWrap"
                                        />
                                    </Grid>
                                </Grid>
                            </div>)
                        break;
                    case 'Radio':
                        arrayDoc.push(
                            //<div style={{ display: 'inline-block', margin: '0 0.2px' }}>
                            <div className="mi-componente-material-ui">
                                <Grid container sx={{ m: 1 }} xs={12} item>
                                    <Grid xs={12} item>
                                        <RadioComponent
                                            name={nameField}
                                            value={field[idField]}
                                            onChange={(event) => handleFieldChange(event, null, idField, itemField.idFieldTable, itemDoc, nameGroup, indexGroup, nameSubGroup, indexSubGroup)}
                                            help={itemField.help}
                                            options={itemField.radioGroup}
                                            mode={false}
                                            className={itemField.print === false ? constant.HIDE_IN_PRINT_CLASS : null}
                                            classNameRow="radio-row"
                                        />
                                    </Grid>
                                </Grid>
                            </div>)
                        break;
                    case 'Date':
                        arrayDoc.push(
                            //<div style={{ display: 'inline-block', margin: '0 0.2px' }}>
                            <div idfield={idField} className="mi-componente-material-ui">
                                <Grid container sx={{ m: 1 }} xs={12} item margin={0}>
                                    <Grid item>
                                        <DateComponent
                                            disabled={itemField.view === 'viewOnly' ? true : false}
                                            id={idField}
                                            name={nameField}
                                            value={field[idField]}
                                            onChange={(event) => handleFieldChange(event, null, idField, itemField.idFieldTable, itemDoc, nameGroup, indexGroup, nameSubGroup, indexSubGroup)}
                                            help={itemField.help}
                                            mode={false}
                                            className={itemField.print === false ? constant.HIDE_IN_PRINT_CLASS : null}
                                        />
                                    </Grid>
                                </Grid>
                            </div>)
                        break;

                    case 'Button':

                        if (itemField.function === 'printPDF') {
                            arrayDoc.push(
                                <div style={{ display: 'inline-block', margin: '0 0.2px' }}>
                                    <Grid>
                                        <Grid>
                                            <ThemeProvider theme={constant.CUSTOM_MUI_BUTTON_THEME}>
                                                {loading && (<div style={{ display: 'inline-block' }}><CircularProgress /><p style={{ "fontSize": "1rem" }}>Generando PDF.....</p></div>)}
                                                {!loading &&
                                                    <Button
                                                        variant='outlined'
                                                        className={`button-back ${itemField.print === false ? constant.HIDE_IN_PRINT_CLASS : null}`}
                                                        onClick={handlePrintTest}>{itemField.name}
                                                    </Button>
                                                }
                                            </ThemeProvider>
                                        </Grid>
                                    </Grid>
                                </div>
                            );
                        }
                        else {
                            if (itemField.name !== 'Siguiente' && itemField.name !== 'Anterior') {

                                let lastPerson = 0;
                                for (let b = 0; b < data.length; b++) {
                                    if (Number(data[b].entityDocId) === 2) {
                                        lastPerson = data[b].id;
                                    }
                                }
                                let stepFlag = Number(activeStep) + 1;

                                if (Number(lastPerson) === Number(stepFlag)) {
                                    let parameter;
                                    let max = 0;
                                    if (itemField.name === 'Agregar Condómino') {
                                        parameter = 'Condómino'
                                        max = constants.constants.maxJointOwner.value;
                                    }
                                    else {
                                        parameter = 'Apoderado'
                                        max = constants.constants.maxProxy.value;
                                    }

                                    if (Number(cantidadCondoApod) < Number(max))
                                        arrayDoc.push(
                                            <div style={{ display: 'inline-block', margin: '0 0.2px' }}>
                                                <Grid container xs={12} item>
                                                    <Grid xs={3} item>
                                                        <ThemeProvider theme={constant.CUSTOM_MUI_BUTTON_THEME}>
                                                            <Button
                                                                variant='outlined'
                                                                className={`button-back ${itemField.print === false ? constant.HIDE_IN_PRINT_CLASS : null}`}
                                                                onClick={() => addCondomino(parameter)}>{itemField.name}
                                                            </Button>
                                                        </ThemeProvider>
                                                    </Grid>
                                                </Grid>
                                            </div>
                                        );
                                }
                            }
                        }

                        break;
                    default:
                        break;
                }

                if (indexField < itemBoxs.fields.length - 1 && itemField.columnBreak) {
                    arrayDoc.push(<br />);
                }
                return true;
            }
        }
    }

    const copySocios = () => {

        let newArrayBeneficiariosFinales = [];
        if (group['4_4_Beneficiarios Finales'])
            newArrayBeneficiariosFinales.push(group['4_4_Beneficiarios Finales'].slice(0, 1)[0])

        newArrayBeneficiariosFinales[0].subGroup[0].subGroup_4_4_Domicilios_BF = [newArrayBeneficiariosFinales[0].subGroup[0].subGroup_4_4_Domicilios_BF[0]]

        group['4_4_Socios'].forEach((itemGroup, index) => {
            if (index === 0) {
                //FIELDS DEL GRUPO
                itemGroup.fields.forEach((itemFields) => {
                    if (group['4_4_Beneficiarios Finales']) {
                        group['4_4_Beneficiarios Finales'].forEach((itemGroup1) => {
                            itemGroup1.fields.forEach((itemFields1) => {
                                if (itemFields1.idFieldTable === itemFields.idFieldTable && itemFields1.idFieldTable !== 'entityRelTypeId') {
                                    let idField1 = itemFields1.id;
                                    if (itemFields1.id.split('_').length === 1)
                                        idField1 = `4_4_${itemFields1.id}`;

                                    let idField2 = itemFields.id;
                                    if (itemFields.id.split('_').length === 1)
                                        idField2 = `4_4_${itemFields.id}`;

                                    if (field[idField2])
                                        setField(prevState => ({
                                            ...prevState,
                                            [idField1]: field[idField2]
                                        }), []);
                                }
                            })
                        })
                    }
                })

                //FIELDS DEL SUBGRUPO                
                itemGroup.subGroup.forEach((itemSubGroup) => {
                    itemSubGroup.subGroup_4_4_Domicilios_Socio.forEach((item, indexSubGroup) => {
                        if (indexSubGroup === 0) {
                            item.fields.forEach((itemFieldsSubGroup) => {
                                if (group['4_4_Beneficiarios Finales']) {
                                    group['4_4_Beneficiarios Finales'].forEach((itemGroup1) => {
                                        itemGroup1.subGroup.forEach((itemSubGroup1) => {
                                            itemSubGroup1.subGroup_4_4_Domicilios_BF.forEach((item1) => {
                                                item1.fields.forEach((itemFieldsSubGroup1) => {

                                                    if (itemFieldsSubGroup1.idFieldTable === itemFieldsSubGroup.idFieldTable) {
                                                        let idField1 = itemFieldsSubGroup1.id;
                                                        if (itemFieldsSubGroup1.id.split('_').length === 1)
                                                            idField1 = `4_4_${itemFieldsSubGroup1.id}`;

                                                        let idField2 = itemFieldsSubGroup.id;
                                                        if (itemFieldsSubGroup.id.split('_').length === 1)
                                                            idField2 = `4_4_${itemFieldsSubGroup.id}`;

                                                        if (field[idField2])
                                                            setField(prevState => ({
                                                                ...prevState,
                                                                [idField1]: field[idField2]
                                                            }), []);
                                                    }
                                                })
                                            })
                                        })
                                    })
                                }
                            })
                        } else {

                            item.fields.forEach((itemFieldsSubGroup) => {
                                itemFieldsSubGroup.value = field[itemFieldsSubGroup.id]
                            })

                            let object = {
                                fields: item.fields
                            }
                            addElementSubGroup('Beneficiarios Finales', '4', 'subGroup_4_4_Domicilios_BF', index, indexSubGroup, object, newArrayBeneficiariosFinales, null);
                        }
                    })
                })

            } else {
                itemGroup.fields.forEach((itemFields) => {
                    itemFields.value = field[itemFields.id]
                })

                let object = {
                    boxes: [
                        {
                            fields: itemGroup.fields
                        }
                    ]
                }
                addElementGroup('Beneficiarios Finales', '4', object, newArrayBeneficiariosFinales, '4');

                //FIELDS DEL SUBGRUPO                
                itemGroup.subGroup.forEach((itemSubGroup) => {
                    itemSubGroup.subGroup_4_4_Domicilios_Socio.forEach((item, indexSubGroup) => {

                        if (indexSubGroup === 0) {
                            item.fields.forEach((itemFieldsSubGroup) => {

                                newArrayBeneficiariosFinales.forEach((itemGroup1, indexGroup1) => {

                                    if (indexGroup1 === index) {

                                        itemGroup1.subGroup.forEach((itemSubGroup1) => {
                                            itemSubGroup1.subGroup_4_4_Domicilios_BF.forEach((item1) => {
                                                item1.fields.forEach((itemFieldsSubGroup1) => {

                                                    if (itemFieldsSubGroup1.idFieldTable === itemFieldsSubGroup.idFieldTable) {
                                                        let idField1 = itemFieldsSubGroup1.id;
                                                        if (itemFieldsSubGroup1.id.split('_').length === 1)
                                                            idField1 = `4_4_${itemFieldsSubGroup1.id}`;

                                                        let idField2 = itemFieldsSubGroup.id;
                                                        if (itemFieldsSubGroup.id.split('_').length === 1)
                                                            idField2 = `4_4_${itemFieldsSubGroup.id}`;

                                                        if (field[idField2])
                                                            setField(prevState => ({
                                                                ...prevState,
                                                                [idField1]: field[idField2]
                                                            }), []);
                                                    }
                                                })
                                            })
                                        })

                                    }
                                })

                            })
                        } else {

                            item.fields.forEach((itemFieldsSubGroup) => {
                                itemFieldsSubGroup.value = field[itemFieldsSubGroup.id]
                            })

                            let object = {
                                fields: item.fields
                            }
                            addElementSubGroup('Beneficiarios Finales', '4', 'subGroup_4_4_Domicilios_BF', index, indexSubGroup, object, newArrayBeneficiariosFinales, null);

                        }
                    })
                })


            }
        })
        setGroup(prevState => ({
            ...prevState,
            '4_4_Beneficiarios Finales': newArrayBeneficiariosFinales
        }));

    }


    const deleteCondomino = (idDelete) => {
        setCantidadCondoApod(cantidadCondoApod - 1);

        let arrayFlag = [];
        let arrayEntityFlag = [];

        for (let h = 0; h < data.length; h++) {
            if (Number(data[h].entityDocId) === 2) {
                if (Number(data[h].id) !== Number(idDelete)) {
                    arrayFlag.push(data[h]);
                    arrayEntityFlag.push(data[h]);
                }
            } else {
                if (Number(data[h].entityIx) !== Number(idDelete)) {
                    arrayFlag.push(data[h]);
                }
            }
        }
        addEntity(arrayFlag);
        let orden = accountSeq - 1;
        setAccountSeq(orden);
        setData(arrayFlag);
        handleBack();
    }



    const addCondomino = (parametro) => {
        setCantidadCondoApod(cantidadCondoApod + 1);
        let orden = 0;
        for (let d = 0; d < data.length; d++) {
            if (Number(data[d].entityDocId) === 2) {
                orden++;
            }
        }
        orden = orden + 1;
        setAccountSeq(orden);

        let tipo = { id: 1, label: 'Titular' };
        if (parametro === 'Condómino')
            tipo = { id: 2, label: 'Condómino' };
        else
            tipo = { id: 3, label: 'Apoderado' };

        if (tipo.id !== 1)
            setEntityPropIdOwner([...entityPropIdOwner, tipo]);

        let addObject;
        let arrayFlag = data;

        let ultimoID = 0;
        for (let h = 0; h < data.length; h++) {
            if (data[h].entityDocId === '2') {
                ultimoID = Number(data[h].id) + 1;
            }
        }

        addEntity(data);
        addScreen(initialData, entity, true);

        let firstCond = false;
        for (let h = 0; h < data.length; h++) {
            if (data[h].entityDocId === '2' && firstCond === false) {
                addObject = JSON.parse(JSON.stringify(data[h]));
                addObject.name = `Datos personales ${parametro} ${orden}`;
                addObject.id = ultimoID;
                addObject.condominoApoderado = true;
                firstCond = true;
            }
        }

        for (let g = 0; g < addObject.boxes.length; g++) {
            for (let d = 0; d < addObject.boxes[g].fields.length; d++) {
                addObject.boxes[g].fields[d].idFlag = orden;

                let idField = `2_${ultimoID}_${addObject.boxes[g].fields[d].id}`;

                switch (addObject.boxes[g].fields[d].type) {
                    case 'Select':
                        setField(prevState => ({
                            ...prevState,
                            [idField]: null
                        }));
                        if (addObject.boxes[g].fields[d].idFieldTable === 'entityTypeId')
                            setField(prevState => ({
                                ...prevState,
                                [idField]: { id: 1, label: 'Humana' }
                            }));
                        else {
                            if (addObject.boxes[g].fields[d].idFieldTable === 'entityPropId')
                                setField(prevState => ({
                                    ...prevState,
                                    [idField]: tipo
                                }));
                        }
                        if (addObject.boxes[g].fields[d].defaultValue) {

                            info.forEach((itemInfo) => {
                                if (itemInfo.source === addObject.boxes[g].fields[d].sourceSelect) {
                                    if (Number(addObject.boxes[g].fields[d].defaultValue) === Number(itemInfo.id)) {

                                        setField(prevState => ({
                                            ...prevState,
                                            [idField]: {
                                                id: itemInfo.id,
                                                label: itemInfo.nameAlt !== undefined ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                                            }
                                        }), []);
                                    }
                                }
                            })
                        }
                        break;
                    case 'MultipleSelect':
                        setField(prevState => ({
                            ...prevState,
                            [idField]: null
                        }));
                        break;
                    case 'List':
                        setField(prevState => ({
                            ...prevState,
                            [idField]: null
                        }));
                        break;
                    case 'Checkbox':
                        setField(prevState => ({
                            ...prevState,
                            [idField]: false
                        }));
                        break;
                    case 'Switch':
                        setField(prevState => ({
                            ...prevState,
                            [idField]: false
                        }));
                        break;
                    case 'Number':
                        setField(prevState => ({
                            ...prevState,
                            [idField]: 0
                        }));
                        break;
                    case 'Currency':
                        setField(prevState => ({
                            ...prevState,
                            [idField]: 0.00
                        }));
                        break;
                    case 'Date':
                        if (addObject.boxes[g].fields[d].defaultValue === 'CURDATE()') {
                            setField(prevState => ({
                                ...prevState,
                                [idField]: new Date().toISOString().split('T')[0]
                            }));
                        } else {
                            setField(prevState => ({
                                ...prevState,
                                [idField]: ''
                            }));
                        }
                        break;
                    default:
                        if (addObject.boxes[g].fields[d].idFieldTable === 'accountSeq') {
                            setField(prevState => ({
                                ...prevState,
                                [idField]: '0' + orden
                            }));
                        }
                        else {
                            if (addObject.boxes[g].fields[d].idFieldTable === 'requestCode') {
                                setField(prevState => ({
                                    ...prevState,
                                    [idField]: addObject.boxes[g].fields[d].value
                                }));
                            }
                            else {
                                setField(prevState => ({
                                    ...prevState,
                                    [idField]: ''
                                }));
                            }
                        }
                        if (addObject.boxes[g].fields[d].defaultValue) {
                            if (!addObject.boxes[g].fields[d].defaultValue.includes('()'))
                                setField(prevState => ({
                                    ...prevState,
                                    [idField]: addObject.boxes[g].fields[d].defaultValue
                                }), []);
                        }
                        break;
                }

                //INICIALIZA GRUPO**
                let objectsGroups = [];

                if (addObject.boxes[g].fields[d].group !== null) {

                    for (var b = 0; b < addObject.boxes[g].fields[d].group.length; b++) {
                        if (b === 0) {
                            let objectGroup = {};
                            let arrayFields = [];
                            let objectsSubGroups = [];
                            let nameGroup = `${addObject.entityDocId}_${addObject.id}_${addObject.boxes[g].fields[d].group[b].name}`;
                            for (var m = 0; m < addObject.boxes[g].fields[d].group[b].fields.length; m++) {

                                if (addObject.boxes[g].fields[d].group[b].fields[m].subGroup !== null) { }
                                else {
                                    let itemFlag = JSON.parse(JSON.stringify(addObject.boxes[g].fields[d].group[b].fields[m]));

                                    arrayFields.push(itemFlag);
                                    let newIdField = `2_${ultimoID}_${itemFlag.id}`
                                    switch (itemFlag.type) {
                                        case 'Select':
                                            if (itemFlag.defaultValue) {
                                                info.forEach((itemInfo) => {
                                                    if (itemInfo.source === itemFlag.sourceSelect) {
                                                        if (Number(itemFlag.defaultValue) === Number(itemInfo.id))
                                                            setField(prevState => ({
                                                                ...prevState,
                                                                [newIdField]: {
                                                                    id: itemInfo.id,
                                                                    label: itemInfo.nameAlt !== undefined ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                                                                }
                                                            }), []);
                                                    }
                                                })
                                            } else {
                                                setField(prevState => ({
                                                    ...prevState,
                                                    [newIdField]: null
                                                }));
                                            }
                                            break;
                                        case 'MultipleSelect':
                                            setField(prevState => ({
                                                ...prevState,
                                                [newIdField]: null
                                            }));
                                            break;
                                        case 'List':
                                            setField(prevState => ({
                                                ...prevState,
                                                [newIdField]: null
                                            }));
                                            break;
                                        case 'Checkbox':
                                            setField(prevState => ({
                                                ...prevState,
                                                [newIdField]: false
                                            }));
                                            break;
                                        case 'Switch':
                                            setField(prevState => ({
                                                ...prevState,
                                                [newIdField]: false
                                            }));
                                            break;
                                        case 'Number':
                                            setField(prevState => ({
                                                ...prevState,
                                                [newIdField]: 0
                                            }));
                                            break;
                                        case 'Currency':
                                            setField(prevState => ({
                                                ...prevState,
                                                [newIdField]: 0.00
                                            }));
                                            break;
                                        case 'Date':
                                            if (itemFlag.defaultValue === 'CURDATE()') {
                                                setField(prevState => ({
                                                    ...prevState,
                                                    [newIdField]: new Date().toISOString().split('T')[0]
                                                }), []);
                                            } else {
                                                setField(prevState => ({
                                                    ...prevState,
                                                    [newIdField]: ''
                                                }));
                                            }
                                            break;
                                        default:
                                            setField(prevState => ({
                                                ...prevState,
                                                [newIdField]: ''
                                            }));
                                            break;
                                    }
                                }

                            }
                            objectGroup.fields = arrayFields;
                            objectGroup.id = addObject.id;
                            objectGroup.name = nameGroup;
                            objectGroup.subGroup = objectsSubGroups
                            objectsGroups.push(objectGroup);
                        }
                    }
                }
                const newArray = groupDataByName(objectsGroups);
                newArray.forEach((groupedArray) => {
                    let nameGroup = groupedArray.name;

                    setGroup(prevState => ({
                        ...prevState,
                        [nameGroup]: groupedArray.props
                    }));
                })

            }
        }
        arrayFlag.push(addObject);
        arrayFlag = orderArray(arrayFlag);
        for (let h = 0; h < arrayFlag.length; h++) {
            for (let t = 0; t < arrayFlag[h].boxes.length; t++) {
                arrayFlag[h].boxes = orderArray(arrayFlag[h].boxes);
                for (let y = 0; y < arrayFlag[h].boxes[t].fields.length; y++) {
                    arrayFlag[h].boxes[t].fields = orderArray(arrayFlag[h].boxes[t].fields);
                }
            }
        }
        setData(arrayFlag);
        handleNext(true);
    }



    const groupDataByName = (data) => {
        const groupedData = data.reduce((acc, obj) => {
            const { name, ...rest } = obj;
            const existingGroup = acc.find((group) => group.name === name);
            if (!existingGroup) {
                acc.push({ name, props: [{ name, ...rest }] });
            } else {
                existingGroup.props.push({ name, ...rest });
            }
            return acc;
        }, []);

        return groupedData;
    };

    const filteredData = data.filter(itemDoc => whereFunctions.whereFunctionHeader(itemDoc, entity));

    const pdfContentRef = UseRef(null);

    const handlePrintTest = async () => {

        setLoading(true);

        //openPrintWindow(printContent);
        pdfPromise();

    };

    const applyStyles = () => {

        for (const itemDoc of filteredData) {
            if (itemDoc.onboardingPrint === true) {
                const idContent = 'pdf_content_' + itemDoc.id + '_' + itemDoc.entityDocId;
                const content = document.getElementById(idContent);

                content.style.transform = 'scale(0.98)';
                const disabledStyle = document.createElement('style');

                const brTags = content.querySelectorAll('br');

                // Ajusta la altura de cada etiqueta <br/> al mínimo posible
                brTags.forEach(br => {
                    br.style.lineHeight = '0'; // Ajusta line-height al mínimo posible
                    br.style.margin = '0'; // Opcional: Ajusta margin al mínimo
                });

                disabledStyle.innerHTML = `
                
                #${idContent} .MuiInputBase-input.MuiOutlinedInput-input {
                    height:auto;
                }

        #${idContent} .Mui-disabled {
            color: rgba(0, 0, 0, 1) !important;
            -webkit-text-fill-color: rgba(0, 0, 0, 1) !important;
        }
        #${idContent} .MuiOutlinedInput-notchedOutline {
            border: none !important;
        }
        #${idContent} .MuiAutocomplete-popupIndicator { 
            display: none !important;
        } 

        #${idContent} .MuiFormControl-root.MuiTextField-root .MuiOutlinedInput-input {
            height:auto;
            padding: 0px 1px 0px 1px;
        }
        #${idContent} .css-1h51icj-MuiAutocomplete-root .MuiOutlinedInput-root {
            height:auto;
            padding: 0px 1px 0px 1px;
          }
        #${idContent} .MuiSvgIcon-root.MuiSvgIcon-colorPrimary.MuiSvgIcon-fontSizeMedium.css-ci5apu-MuiSvgIcon-root {
            font-size: 1rem !important; 
          }
        #${idContent} .MuiSvgIcon-root.MuiSvgIcon-fontSizeMedium.css-i4bv87-MuiSvgIcon-root{
            font-size: 1rem !important; 
        }
        #${idContent} .MuiFormControl-root {
            margin-right: 1px !important; 
        }
        #${idContent} .MuiSwitch-root {
            width: 50px; 
            height: 30px; 
          }
          #${idContent} .MuiSwitch-thumb {
            width: 10px;
            height: 10px;
          }

          #${idContent} .MuiFormControl-root .MuiInputLabel-root:not(.MuiInputLabel-shrink) {
            transform: translate(0, 0rem) scale(0.75);
            pointer-events: none;
        }

        #${idContent} .css-18nc3u2 .MuiOutlinedInput-root {
            height:auto !important; 
            padding: 0px 1px 5px 1px !important; 
          }
        `;

                content.appendChild(disabledStyle);

                const hideElements = content.querySelectorAll('.hide-in-print');

                hideElements.forEach(element => {
                    element.style.display = 'none';
                });

                const switchIconElements = content.querySelectorAll('.pdf-switch-icon');
                switchIconElements.forEach(element => {
                    element.style.fontSize = '2rem';
                });

                const miComponentes = content.querySelectorAll('.mi-componente-material-ui');
                miComponentes.forEach((componente) => {
                    const id = componente.getAttribute('idfield');
                    if (id !== undefined && id !== null) {
                        let contenido = field[id];
                        if (contenido !== null && contenido !== undefined) {
                            if (typeof field[id] === 'object') {
                                contenido = field[id].label;
                            }

                            let idFlag = id.split('_');
                            if (idFlag.length > 2)
                                idFlag = idFlag[2];//porcentaje de socios
                            else
                                idFlag = null;

                            if (contenido.length > 17 || idFlag === '162' || idFlag === '95') {
                                componente.style.width = 'auto';
                            } else {
                                componente.style.width = '123px';
                            }
                        }
                    }
                });

                const inputs = content.querySelectorAll('.MuiInputBase-input');
                inputs.forEach(input => {
                    input.style.height = 'auto';
                });

            }
        }

        const content = pdfContentRef.current.innerHTML;
        const styles = Array.from(document.styleSheets)
            .map((styleSheet) => {
                try {
                    return Array.from(styleSheet.cssRules)
                        .map((rule) => rule.cssText)
                        .join('\n');
                } catch (e) {
                    console.warn('Could not read CSS rules from stylesheet', styleSheet.href, e);
                    return '';
                }
            })
            .join('\n');

        // Estilos específicos para la impresión
        const printStyles = `
        @page {
          margin: 5mm; 
        }
      
        @media print {
                header, footer {
              display: none;
          }
        }
      `;


        const printContent = `
      <html>
        <head>
          <meta charset="UTF-8">
          <style>${styles}</style>
          <style>${printStyles}</style>
        </head>
        <body>
          ${content}
        </body>
      </html>
    `;

        return printContent;

    }

    const pdfPromise = () => {
        let printContent = applyStyles();
        const options = {
            margin: 0,
            filename: 'document.pdf',
            image: { type: 'jpeg', quality: 0.10 },
            pagebreak: { mode: ['avoid-all', 'css', 'legacy'] },
            html2canvas: { scale: 1.8 },
            jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
        };

        html2pdf().from(printContent).set(options).outputPdf('blob')
            .then(pdfBlob => {
                sendEmailSolicitud(pdfBlob);
            })
            .catch(error => {
                console.error('Error al convertir HTML a PDF o enviar por correo electrónico:', error);
            });
    }

    const sendEmailSolicitud = (pdfBlob) => {

        let msgBody = '';
        let subject = '';
        const variables = { requestCode };

        for (let k = 0; k < emails.length; k++) {
            if (emails[k].id === 'requirement') {
                for (let d = 0; d < emails[k].type.length; d++) {
                    if (emails[k].type[d].name === 'generatedOrder') {
                        msgBody = emails[k].type[d].msgBody;
                        msgBody = msgBody.replace(/\$_(\w+)/g, (match, p1) => variables[p1] || match);
                        msgBody = msgBody.replace(/\\n/g, '\n');

                        subject = emails[k].type[d].subject;
                        subject = subject.replace(/\$_(\w+)/g, (match, p1) => variables[p1] || match);
                        subject = subject.replace(/\\n/g, '\n');
                    }
                }
            }
        }

        const formData = new FormData();

        formData.append('recipient', field['1_1_15']);
        formData.append('msgBody', msgBody);
        formData.append('subject', subject);
        //formData.append('msgBody', `La solicitud ha sido generada correctamente: \n\nID Órden: ${requestCode}\n\nSaludos \n\nWinvest APP`);
        //formData.append('subject', `Solicitud Generada:  + ${requestCode}`);
        formData.append('attachment', new Blob([pdfBlob], { type: 'application/pdf' }), `Solicitud órden ${requestCode}.pdf`);

        try {
            emailService.sendEmailAttachment(formData).then(responseEmail => {
                openPrintWindow();
            }).catch(error => {
                console.log(error)
            });
        } catch (error) {
            console.error("Error al enviar el correo electrónico:", error);
        }
    }

    const openPrintWindow = () => {
        let printContent = applyStyles();

        const printWindow = window.open('', '_self');

        printWindow.document.title = order;

        printWindow.document.write(printContent);

        printWindow.print();

        printWindow.close();
        let docId = [1];
        for (let i = 2; i <= docIdSave; i++) {
            docId.push(i);
        }
        saveOrder(requestCode, docId, 'Solicitud Enviada');
        setLoading(false);
        window.location.reload();
    };


    return (

        <ThemeProvider theme={constant.CUSTOM_MUI_GENERAL_THEME}>
            <div className="App">
                <CssBaseline />
                <header className="App-header">
                    <Box ref={boxRef} sx={{ flexGrow: 1 }}>
                        <Grid container xs={12} item>
                            <Grid container sx={{ m: 1 }} xs={12} item>
                                <ThemeProvider theme={constant.CUSTOM_MUI_TEXT_FIELD_THEME}>
                                    <Box sx={{ width: '100%' }}>
                                        <Stepper className={constant.HIDE_IN_PRINT_CLASS} activeStep={activeStep}>
                                            {

                                                filteredData.map((item, index) => {
                                                    return (
                                                        <Tooltip key={index} title={item.name}>
                                                            <Step key={index} onClick={() => redirectError(index)}>
                                                                <StepLabel></StepLabel>
                                                            </Step>
                                                        </Tooltip>
                                                    );
                                                })
                                            }
                                        </Stepper>
                                        <div style={{ height: '10px' }} />
                                        {activeStep === data.length ? (
                                            <Fragment>

                                            </Fragment>
                                        ) : (
                                            <Fragment>

                                                {

                                                    filteredData.map((itemDoc, indexDoc) => {
                                                        let arrayDoc = [];
                                                        if (indexDoc === activeStep) {
                                                            itemDoc.boxes.forEach((itemBoxs, indexBoxs) => {

                                                                let arrayItemBoxs = [];
                                                                let arrayItemBoxsFlag = [];
                                                                let title = false;

                                                                if (itemDoc.condominoApoderado === true && indexBoxs === 0)
                                                                    arrayItemBoxs.push(<Button onClick={() => { deleteCondomino(itemDoc.id) }}>
                                                                        <PersonRemoveIcon />
                                                                    </Button>);

                                                                itemBoxs.fields.forEach((itemField, indexField) => {
                                                                    if (itemField.group !== null) {
                                                                        itemField.group.forEach((itemGroup, indexGroup) => {
                                                                            if (indexGroup === 0) {

                                                                                let nameGroup = `${itemDoc.entityDocId}_${itemDoc.id}_${itemGroup.name}`;
                                                                                console.log('nameGroup-> ' + JSON.stringify(nameGroup))
                                                                                if (group[nameGroup]) {

                                                                                    group[nameGroup].forEach((item1, index) => {
                                                                                        let arrayItemGroup = [];
                                                                                        if (item1 !== undefined) {
                                                                                            if (item1.fields !== null) {
                                                                                                let viewFieldFlag = false;
                                                                                                item1.fields.forEach((itemFields, indexFields) => {
                                                                                                    let viewFlag = renderFields(itemFields, indexFields, itemDoc, arrayItemGroup, itemBoxs, nameGroup, index, viewFieldFlag, false, null, null);
                                                                                                    if (viewFlag === true) {
                                                                                                        viewFieldFlag = true;
                                                                                                    }
                                                                                                })
                                                                                                if (itemGroup.name === 'Errores') {
                                                                                                    arrayItemGroup.push(<Button onClick={() => { redirect(item1.idDocumentError) }}>
                                                                                                        <ArrowRight style={{ fontSize: '20px' }} />
                                                                                                    </Button>);
                                                                                                }
                                                                                                if (itemGroup.name !== 'Cónyuge' && itemGroup.name !== 'Firmantes' && itemGroup.name !== 'Cargo' && itemGroup.name !== 'Errores' && nameGroup !== '4_4_Teléfono' && nameGroup !== '4_4_Domicilio') {

                                                                                                    //if (itemGroup.name !== 'Adjuntos') {
                                                                                                    if (itemGroup.name !== 'Req') {
                                                                                                        if (group[nameGroup].length > 1 && index > 0) {
                                                                                                            arrayItemGroup.push(<Button onClick={() => { onDeleteElementGroup(index, nameGroup) }}>
                                                                                                                <DeleteIcon style={{ fontSize: '20px' }} />
                                                                                                            </Button>)
                                                                                                        }

                                                                                                        if (index === group[nameGroup].length - 1) {
                                                                                                            if (itemGroup.name === 'Autorizados') {
                                                                                                                let max = constants.constants.maxAuthorized.value;
                                                                                                                if (group[nameGroup].length < max) {
                                                                                                                    arrayItemGroup.push(<Button onClick={() => { addElementGroup(itemGroup.name, itemDoc.id, null, null, itemDoc.entityDocId) }}>
                                                                                                                        <AddCircleIcon style={{ fontSize: '20px' }} />
                                                                                                                    </Button>);
                                                                                                                }
                                                                                                            } else {
                                                                                                                arrayItemGroup.push(<Button onClick={() => { addElementGroup(itemGroup.name, itemDoc.id, null, null, itemDoc.entityDocId) }}>
                                                                                                                    <AddCircleIcon style={{ fontSize: '20px' }} />
                                                                                                                </Button>);

                                                                                                            }
                                                                                                        }
                                                                                                    }
                                                                                                }

                                                                                                if (itemGroup.name === 'Firmantes' || itemGroup.name === 'Cargo') {
                                                                                                    title = true
                                                                                                }

                                                                                                //SUBGROUP
                                                                                                if (item1.subGroup !== null && item1.subGroup !== undefined) {
                                                                                                    item1.subGroup.forEach((item2, index2) => {

                                                                                                        for (let key in item2) {

                                                                                                            let nameSubGroup = key;
                                                                                                            item2[nameSubGroup].forEach((itemSubGroupFields, indexItemSubGroupFields) => {

                                                                                                                let arrayItemSubGroup = [];
                                                                                                                let viewFieldFlag = false;
                                                                                                                itemSubGroupFields.fields.forEach((itemFields, indexFields) => {
                                                                                                                    let viewFlag = renderFields(itemFields, indexFields, itemDoc, arrayItemSubGroup, itemBoxs, nameGroup, index, itemDoc.entityDocId, true, nameSubGroup, indexItemSubGroupFields);
                                                                                                                    if (viewFlag === true) {
                                                                                                                        viewFieldFlag = true;
                                                                                                                    }
                                                                                                                })
                                                                                                                if (viewFieldFlag === true) {
                                                                                                                    if (item2[nameSubGroup].length > 1) {
                                                                                                                        arrayItemSubGroup.push(<Button onClick={() => { onDeleteElementSubGroup(indexItemSubGroupFields, nameSubGroup, itemGroup.name, itemDoc.id, index, itemDoc.entityDocId) }}>
                                                                                                                            <DeleteIcon style={{ fontSize: '20px' }} />
                                                                                                                        </Button>)
                                                                                                                    }
                                                                                                                    if (indexItemSubGroupFields === item2[nameSubGroup].length - 1) {
                                                                                                                        arrayItemSubGroup.push(<Button onClick={() => { addElementSubGroup(itemGroup.name, itemDoc.id, nameSubGroup, index, indexItemSubGroupFields, null, null, item1.idAdjunto) }}>
                                                                                                                            <AddCircleIcon style={{ fontSize: '20px' }} />
                                                                                                                        </Button>);
                                                                                                                    }
                                                                                                                    //if (nameSubGroup.split('_')[4] === 'versions') {
                                                                                                                    if (nameSubGroup.split('_')[4] === 'version') {
                                                                                                                        for (let x = 0; x < fileURL.length; x++) {
                                                                                                                            if (fileURL[x].nameSubGroup === nameSubGroup && fileURL[x].indexSubGroup === indexItemSubGroupFields) {
                                                                                                                                arrayItemSubGroup.push(<Button href={fileURL[x].file} target="_blank" rel="noopener noreferrer">
                                                                                                                                    <DriveFileMoveIcon style={{ fontSize: '20px' }} />
                                                                                                                                </Button>);
                                                                                                                            }
                                                                                                                        }
                                                                                                                    }
                                                                                                                }
                                                                                                                if (arrayItemSubGroup.length > 0) {
                                                                                                                    arrayItemGroup.push(<Box border={1} borderColor="grey.400" borderRadius="4px" p={2} padding={1}>
                                                                                                                        {arrayItemSubGroup}
                                                                                                                    </Box>);
                                                                                                                    arrayItemGroup.push(<div style={{ height: '4px' }} />);
                                                                                                                }
                                                                                                            })
                                                                                                        }
                                                                                                    })
                                                                                                }
                                                                                            }
                                                                                        }

                                                                                        if (arrayItemGroup.length > 1) {

                                                                                            arrayItemBoxsFlag.push(<Box border={1} borderColor="grey.400" borderRadius="4px" p={2} padding={1}>

                                                                                                {arrayItemGroup}
                                                                                                {nameGroup === '4_4_Beneficiarios Finales' && (

                                                                                                    <Button onClick={() => { copySocios() }}>
                                                                                                        <CopyAll /> Copiar Socios
                                                                                                    </Button>

                                                                                                )}
                                                                                            </Box>);
                                                                                            arrayItemBoxsFlag.push(<div style={{ height: '4px' }} />);
                                                                                        }
                                                                                    })
                                                                                }
                                                                            }
                                                                        })

                                                                    } else {
                                                                        let response = renderFields(itemField, indexField, itemDoc, arrayItemBoxsFlag, itemBoxs, null, null, true, null, null, null);
                                                                        if (response === true)
                                                                            title = true;
                                                                    }
                                                                })

                                                                if (arrayItemBoxsFlag.length > 0) {

                                                                    if (itemBoxs.box && title) {
                                                                        arrayItemBoxs.push(<Grid container sx={{ m: 1 }} xs={12} item>
                                                                            <Grid item><TypographyComponent
                                                                                paragraphType='body1'
                                                                                text={itemBoxs.box}
                                                                            /></Grid>
                                                                        </Grid>)
                                                                    }
                                                                    for (let d = 0; d < arrayItemBoxsFlag.length; d++) {
                                                                        arrayItemBoxs.push(arrayItemBoxsFlag[d]);
                                                                    }
                                                                }

                                                                if (arrayItemBoxs.length >= 1) {
                                                                    arrayDoc.push(<Box border={1} borderColor="grey.400" borderRadius="4px" p={2} padding={1}>
                                                                        {arrayItemBoxs}
                                                                    </Box>);

                                                                    if (itemDoc.boxes.length - 1 !== indexBoxs)
                                                                        arrayDoc.push(<div style={{ height: '8px' }} />);
                                                                }
                                                            })
                                                        }
                                                        if (arrayDoc.length > 0) {
                                                            return (
                                                                <Box border={1} borderColor="grey.400" borderRadius="4px" p={2} padding={1}>
                                                                    {arrayDoc}
                                                                </Box>
                                                            );
                                                        }
                                                        return null;
                                                    })
                                                }

                                                {fieldValidation && (
                                                    <div id="pdf-content" ref={pdfContentRef}>
                                                        {


                                                            filteredData.map((itemDoc, indexDoc) => {
                                                                const filteredDataFiltered = filteredData.filter(itemDoc1 => itemDoc1.onboardingPrint === true);

                                                                let arrayDoc = [];
                                                                if (itemDoc.onboardingPrint === true) {

                                                                    itemDoc.header.forEach((itemHeader) => {
                                                                        arrayDoc.push(<img alt='' src={logoTest} />)
                                                                    })
                                                                    itemDoc.boxes.forEach((itemBoxs, indexBoxs) => {

                                                                        let arrayItemBoxs = [];
                                                                        let arrayItemBoxsFlag = [];
                                                                        let title = false;

                                                                        itemBoxs.fields.forEach((itemField, indexField) => {
                                                                            if (itemField.group !== null) {
                                                                                itemField.group.forEach((itemGroup, indexGroup) => {
                                                                                    if (indexGroup === 0) {
                                                                                        let nameGroup = `${itemDoc.entityDocId}_${itemDoc.id}_${itemGroup.name}`;
                                                                                        if (group[nameGroup]) {

                                                                                            group[nameGroup].forEach((item1, index) => {

                                                                                                if (Number(item1.id) === Number(itemDoc.id)) {

                                                                                                    arrayDoc.push(<br />);
                                                                                                    let arrayItemGroup = [];
                                                                                                    if (item1.fields !== null) {
                                                                                                        let viewFieldFlag = false;
                                                                                                        item1.fields.forEach((itemFields, indexFields) => {
                                                                                                            let viewFlag = false;
                                                                                                            if (itemFields.type !== 'File' && itemFields.print === true) {
                                                                                                                viewFlag = renderFields(itemFields, indexFields, itemDoc, arrayItemGroup, itemBoxs, nameGroup, index, viewFieldFlag, false, null, null);
                                                                                                            }
                                                                                                            if (viewFlag === true) {
                                                                                                                viewFieldFlag = true;
                                                                                                            }
                                                                                                        })

                                                                                                        //SUBGROUP
                                                                                                        if (item1.subGroup !== null && item1.subGroup !== undefined) {
                                                                                                            item1.subGroup.forEach((item2) => {

                                                                                                                for (let key in item2) {
                                                                                                                    let nameSubGroup = key;
                                                                                                                    item2[nameSubGroup].forEach((itemSubGroupFields, indexItemSubGroupFields) => {
                                                                                                                        arrayDoc.push(<br />);
                                                                                                                        let arrayItemSubGroup = [];
                                                                                                                        itemSubGroupFields.fields.forEach((itemFields, indexFields) => {
                                                                                                                            //let viewFlag = false;
                                                                                                                            if (itemFields.type !== 'File' && itemFields.print === true) {
                                                                                                                                //viewFlag = renderFields(itemFields, indexFields, itemDoc, arrayItemSubGroup, itemBoxs, nameGroup, index, itemDoc.entityDocId, true, nameSubGroup, indexItemSubGroupFields);
                                                                                                                                renderFields(itemFields, indexFields, itemDoc, arrayItemSubGroup, itemBoxs, nameGroup, index, itemDoc.entityDocId, true, nameSubGroup, indexItemSubGroupFields);
                                                                                                                            }
                                                                                                                            /*if (viewFlag === true) {
                                                                                                                                viewFieldFlag = true;
                                                                                                                            }*/
                                                                                                                        })
                                                                                                                        if (arrayItemSubGroup.length > 0) {
                                                                                                                            arrayItemGroup.push(<Box border={1} borderColor="grey.400" borderRadius="4px" p={2} padding={1}>
                                                                                                                                {arrayItemSubGroup}
                                                                                                                            </Box>);
                                                                                                                            arrayItemGroup.push(<div style={{ height: '4px' }} />);
                                                                                                                        }
                                                                                                                    })
                                                                                                                }
                                                                                                            })
                                                                                                        }

                                                                                                    }
                                                                                                    if (arrayItemGroup.length > 1) {
                                                                                                        arrayItemBoxsFlag.push(<Box border={1} borderColor="grey.400" borderRadius="4px" p={2} padding={1}>

                                                                                                            {arrayItemGroup}

                                                                                                        </Box>);
                                                                                                        arrayItemBoxsFlag.push(<div style={{ height: '4px' }} />);
                                                                                                    }
                                                                                                }
                                                                                            })
                                                                                        }
                                                                                    }
                                                                                })

                                                                            } else {
                                                                                if (itemField.type !== 'File' && itemField.print === true) {
                                                                                    let response = renderFields(itemField, indexField, itemDoc, arrayItemBoxsFlag, itemBoxs, null, null, true, null, null, null);
                                                                                    if (response === true)
                                                                                        title = true;
                                                                                }
                                                                            }
                                                                        })

                                                                        if (arrayItemBoxsFlag.length > 0) {

                                                                            if (itemBoxs.box && title) {
                                                                                arrayItemBoxs.push(<Grid container sx={{ m: 1 }} xs={12} item>
                                                                                    <Grid item><TypographyComponent
                                                                                        paragraphType='body1'
                                                                                        text={itemBoxs.box}
                                                                                    /></Grid>
                                                                                </Grid>)
                                                                            }
                                                                            for (let d = 0; d < arrayItemBoxsFlag.length; d++) {
                                                                                arrayItemBoxs.push(arrayItemBoxsFlag[d]);
                                                                            }
                                                                        }

                                                                        if (arrayItemBoxs.length >= 1) {
                                                                            arrayDoc.push(<Box border={1} borderColor="grey.400" borderRadius="4px" p={2} padding={1}>
                                                                                {arrayItemBoxs}
                                                                            </Box>);
                                                                            if (itemDoc.boxes.length - 1 !== indexBoxs)
                                                                                arrayDoc.push(<div style={{ height: '8px' }} />);
                                                                        }
                                                                    })
                                                                    const isLastElement = indexDoc === filteredDataFiltered.length - 1;
                                                                    if (!isLastElement) {
                                                                        arrayDoc.push(<div className="html2pdf__page-break page-break"></div>);
                                                                    }

                                                                    return <div id={'pdf_content_' + itemDoc.id + '_' + itemDoc.entityDocId}>{arrayDoc}</div>;
                                                                }
                                                                return null;
                                                            })
                                                        }
                                                    </div>
                                                )}

                                                <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>

                                                    <Button
                                                        color="inherit"
                                                        disabled={activeStep === 0 || activeStep === 1}
                                                        onClick={handleBack}
                                                        sx={{ mr: 1 }}
                                                        className={constant.HIDE_IN_PRINT_CLASS}
                                                        style={{ fontSize: '0.8rem' }}
                                                    >
                                                        Anterior
                                                    </Button>

                                                    <Box sx={{ flex: '1 1 auto' }} />
                                                    {!loading && (activeStep <= 5 || activeStep !== filteredData.length - 1) &&
                                                        <Button style={{ fontSize: '0.8rem' }} className={constant.HIDE_IN_PRINT_CLASS} onClick={() => handleNext(false)}>
                                                            Siguiente
                                                        </Button>

                                                    }
                                                    {loading && <CircularProgress />}
                                                </Box>
                                            </Fragment>
                                        )}
                                    </Box>
                                </ThemeProvider>
                            </Grid>
                        </Grid>
                    </Box>
                </header>
            </div>
        </ThemeProvider>
    )
}

export default index